import i18next from 'i18next';
import { initReactI18next } from "react-i18next";
import languagedetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { TITLE, ABOUT_US, BAMBOO_FARMERS_TITLE, BAMBOO_FARMERS_CONTENT, HIT_TITLE, HIT_CONTENT, LLE_TITLE, LLE_CONTENT, TRANSPORTER_TITLE, TRANSPORTER_CONTENT, NEWS, NEWS_CONTENT, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, BLOCK_LIST, WITHIN_25_KM, BEYOND_25_KM, ADJACENT_DISTRICT, OTHER_DISTRICT, MORE_THAN_4_BIGAH, BTWN_3_4_BIGAH, WITHIN_100_METER, BTWN_100_500_METER, BTWN_500_1_METER, MORE_THAN_8_HR, BTWN_6_8_HR, BTWN_4_6_HR, CANCEL_POPOVER, ADD_POPOVER, UPDATE_POPOVER, NO_DATA_AVAILABLE } from './common/constants';


const backend = new Backend({
    // path where resources get loaded from

    loadPath: 'C:/home/site/wwwroot/locales//{{lng}}/{{ns}}.json'
    //loadPath: '/locales/{{lng}}/{{ns}}.json'
});

i18next
    .use(languagedetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: true,
        resources: {
            en: {
                translation: {
                    "main": {
                        "header": TITLE,
                        "home": "Home",
                        "about": "About",
                        "aboutUs": "About Us",
                        "services": "Services",
                        "portfolio": "Portfolio",
                        "contact": "Contact",
                        "login": "Login",
                        "register": "Register",
                        "copyright": "Assam Bio Ethanol Private Limited. All Right Reserved.",
                        "sitemap": "Sitemap",
                        "contactDetails": "Contact details",
                        "address": "Address",
                        "abeplLogin": "ABEPL Login",
                        "userLogin": "User Login",
                        "welcome": "Welcome to",
                        "abepl": "ABEPL",
                        "readmore": "Read More",
                        "news": "ABEPL News",
                        "newsContent": NEWS,
                        "status": "Check Application Status",
                        "check": "Check Status",
                        "para1": ABOUT_US[0],
                        "para2": ABOUT_US[1],
                        "para3": ABOUT_US[2],
                        "para4": ABOUT_US[3],
                        "one": '1',
                        "two": "2",
                        "three": "3",
                        "four": "4",
                        "five": "5",
                        "farmersTitle": BAMBOO_FARMERS_TITLE,
                        "farmersContent": BAMBOO_FARMERS_CONTENT,
                        "hitTitle": HIT_TITLE,
                        "hitContent": HIT_CONTENT,
                        "lleTitle": LLE_TITLE,
                        "lleContent": LLE_CONTENT,
                        "transporterTitle": TRANSPORTER_TITLE,
                        "transporterContent": TRANSPORTER_CONTENT,
                        "terms": "Terms of Use",
                        "privacy": "Privacy Policy",
                        "copyright": "Copyright",
                        "allrightsReserved": "All Rights Reserved",
                        "officeAddressTitle": "Registered office address",
                        "siteOfficeTitle": "Site office address",
                        "contactNos": "Contact no.s",
                        "abeplName": "Assam Bio Ethanol Pvt. Ltd.",
                        "abeplAdd1": "NRL Building, 122A, G.S.Road",
                        "abeplAdd2": "Christianbasti, Guwahati, Assam, India",
                        "abeplpin": "Pin - 781005",
                        "email": "E-mail",
                        "siteAdd1": "Post Box No. : 003, P.O.: NR Project",
                        "siteAdd2": "Dist.: Golaghat, Assam, India",
                        "sitepin": "PIN - 785699",
                        "siteContact": "Contact no.: +91 3776 281015 (Time: 8 AM to 5 PM)",
                        "contact1": "Dr. Pranab Kr. Nath- +91 8638616672  ",
                        "contact2": "Mr. Hidam Tonsana- +91 7428696616",
                        "contact3": "Mr. Masood Iqbal- +91 8811035162",
                        "contact4": "Mr. Tonmoy Chutia- +91 9643148452",
                        "title": "Assam Bio Ethanol Private Limited",
                        "footer": "Assam Bio Ethanol Private Limited. All Rights Reserved.",
                    },
                    // "admin": {
                    //     "registeredStakeholders": "REGISTERED STAKEHOLDERS",
                    //     "activeApplications": "Active Applications",
                    //     "newRegistrations": "New Registrations",
                    //     "shortlisted": "Shortlisted",
                    //     "waitlisted": "Waitlisted",
                    //     "issueRaised": "ISSUES RAISED",
                    //     "comingSoon": "COMING SOON !!!!",
                    //     "upcomingTasks": "UPCOMING TASKS",
                    //     "manageScrutiniser": "MANAGE SCRUTINISER",
                    //     "pendingTasks": "PENDING TASKS",
                    //     "mapView": "MAP VIEW",
                    //     "viewAll": "View all",
                    //     "helpdesk": "Helpdesk",
                    //     "quality": "Quality",
                    //     "dashboard": "Dashboard",
                    //     "pit": "PIT",
                    //     "registration": "Registration",
                    //     "demand": "Demand",
                    //     "payment": "Payment",
                    //     "welcome": "Welcome",
                    //     "signOut": "Sign Out"
                    // },
                    "preReg": {
                        "enterMobileNoOrUrn": "Enter Mobile No./URN",
                        "imNotRobot": "I’m not a robot",
                        "heading": "Stakeholder Pre-Registration",
                        "subheading": "Select a Category of Stakeholder",
                        "transporter": "Transporter",
                        "r": " ",
                        "lle": "LLE",
                        "lleSub": "Local Level Enterpreneur",
                        "hit": "HIT",
                        "hitSub": "Harvester Cum Interim Transporter",
                        "grower": "Grower",
                        "growerSub": "Sub-category of Growers are JFMC, SHG, Forest, FPO, FPC, Co-operative and Other Agency",
                        "intrimStorage": "Interim Storage Operator",
                        "individual": "Individual",
                        "fpo": "FPO",
                        "fpc": "FPC",
                        "jfmc": "JFMC",
                        "forest": "Forest",
                        "shg": "SHG",
                        "cooperative": "Co-operative",
                        "enterprise": "Enterprise",
                        "subCategorySelection": "Select sub-category",
                        "pre-registration": "Pre-Registration",
                        "name": "Name",
                        "personalDetails": "Personal Details",
                        "organizationDetails": "Organization Details",
                        "salutation": "Salutation",
                        "firstname": "First Name",
                        "middlename": "Middle Name",
                        "lastname": "Last Name ",
                        "gender": "Gender",
                        "mobileNo": "Mobile no.",
                        "otp": "Enter OTP",
                        "permanentAddress": "Permanent Address",
                        "bambooDetails": "Bamboo Details",
                        "totalPlotArea": "Total Plot Area",
                        "totalClumps": "Total Number of Clumps",
                        "plotAddress": "Plot address",
                        "pincode": "Pincode",
                        "state": "State",
                        "district": "District",
                        "revenueBlock": REVENUE_BLOCK_DEFAULT_VALUE,
                        "revenueCircle": REVENUE_CIRCLE,
                        "blockOffice": BLOCK_LIST,
                        "sameasPermanentAdd": "same as permanent address",
                        "sameasRegisteredAdd": "same as registered address",
                        "applicantType": "Type of Applicant",
                        "partnership": "Partnership",
                        "proprietorship": "Proprietorship",
                        "pvtLtdCompany": "Pvt. Ltd. Company",
                        "applicantName": "Name of Applicant",
                        "contactPersonDetails": "Contact Person Details",
                        "contactPerson": "Contact Person",
                        "contactDetails": "Contact Details",
                        "registeredAddress": "Registered Address",
                        "submit": "Submit",
                        "firm": "Firm",
                        "company": "Company",
                        "next": "Next",
                        "vehicleDetails": "Vehicle Details",
                        "vehicleType": "Vehicle Type",
                        "ownedVehicle": "Owned Vehicles",
                        "rentedVehicle": "Rented Vehicles",
                        "lcv": "LCV",
                        "hcv": "HCV",
                        "mcv": "MCV",
                        "areasOfOperation": "Areas of Operation",
                        "previous": "Previous",
                        "applicantGeneralInfo": "General Applicant Information",
                        "qualification": "Qualification",
                        "highestQualification": "Highest Educational Qualification",
                        "credentials": "Credentials",
                        "typeOfBusinessOccupation": "Type of Business/Occupation",
                        "financialInformation": "Financial Information",
                        "networth": "Net Worth",
                        "inINR": "(in INR)",
                        "workingCapital": "Working Capital",
                        "optedChippingLocationDetails": "Details of location opted for opening Chipping unit",
                        "landArea": "Land Area",
                        "existingLandArea": "Existing Land Area",
                        "availableLandArea": "Available Land Area",
                        "estimatedBambooAvailability": "Estimated Bamboo Availability",
                        "within4050radius": "(within 40-50km radius)",
                        "quantity": "Quantity (MT)",
                        "informationAboutOptedLocation": "Information About Opted Location",
                        "applicantPermanentResidence": "Applicant’s permanent residence within the area of operation ",
                        "within25km": "Within 25 kms from the opted location of same district",
                        "beyond25km": "Beyond 25 kms but same district of opted location",
                        "adjacentDistrict": "From adjacent district",
                        "otherDistrict": "From any other districts of the state",
                        "availabilitOfLandForChippingUnit": "Availability of land for Chipping Unit",
                        "ownOrlease": "(own or on lease)",
                        "morethan4bighas": MORE_THAN_4_BIGAH,
                        "between3to4bighas": BTWN_3_4_BIGAH,
                        "optedLandDescript": "Opted plot is non-agricultural land and at a minimum distance of 500 meters away from hospitals, educational institutions, courts, religious places etc. Land should be free from flood and water logging.",
                        "ownnershipType": "Ownership type",
                        "owned": "Owned",
                        "lease": "Leased",
                        "rented": "Rented",
                        "uploadUdyamCertificate": "(Copy of Udyam Certificate / Attach appropriate supporting documents)",
                        "uploadProofOfResidence": "Upload proof of residence",
                        "uploadJamabandiKhajnaTax": "Upload Jamabandi /Khajana or Tax paid receipt",
                        "uploadJamabandiReceiptLandOwnerTax": "Upload Jamabandi/Khajana or Tax paid receipt of Landowner/Agreement with Landowner",
                        "roadConnectivity": "Road connectivity to the opted plot",
                        "roadConnectivityDescrip": "The road is motorable for movement of heavy trucks of at least 18-ton load capacity throughout the year and should be close and connected to National/State Highway.",
                        "optedPlotIs": "The opted plot is",
                        "adjacentToBitumenBlockRoad": "Adjacent to an existing bitumen/block road",
                        "adjacentToMotorableGravelRoad": "Adjacent to an existing motorable gravel road",
                        "requireAdditionalRoad": "Requires additional road development less than 500 meters",
                        "powerConnectivity11kvline": "Power connectivity of 11 KV line",
                        "distanceFromDistribution": "Distance from the nearest distribution point to the opted plot should be minimum. Dedicated Transformer for the connected load is installed.",
                        "powerConnectionAvailable": "Power connection for the opted plot is available",
                        "within100mtr": WITHIN_100_METER,
                        "btwn100_500mtr": BTWN_100_500_METER,
                        "btwn500mtr_1km": BTWN_500_1_METER,
                        "daytimePowerAvailability": "Power availability during daytime",
                        "powerAvailabilityDescrip": "Average duration of power availability in the locality and opted plot should be good. Capable of providing an alternate power supply will be an additional capacity.",
                        "powerAvailableFor": "During daytime power is available for",
                        "moreThan8hour": MORE_THAN_8_HR,
                        "btwn6_8hour": BTWN_6_8_HR,
                        "btwn4_6hour": BTWN_4_6_HR,
                        "fullAddress": "Full Address",
                        "latitude": "Latitude",
                        "longitude": "Longitude",
                        "bankDetails": "Bank Details",
                        "accountNo": "Account Number",
                        "accountHolderName": "Account Holder Name",
                        "ifscCode": "IFSC Code",
                        "branch": "Branch",
                        "uploadPassbookCancelledCheck": "Upload front page of passbook/ cancelled cheque",
                        "gstNo": "GST No.",
                        "uploadGst": "Upload GST document",
                        "nonEcumbranceCertificateNo": "Non-Encumbrance Certificate No.",
                        "uploadNonEcumbraceDoc": "Upload Non-Encumbrance Certificate",
                        "uploadValuationDueDiligence": "Upload Valuation Report and Due Diligence Report",
                        "agreementDetails": "Agreement Details",
                        "licenseAgreementDetails": "License & Agreement Details",
                        "qualificationFinancialDetails": "Qualification & Financial Information",
                        "agreementStartDate": "Agreement Start Date",
                        "agreementEndDate": "Agreement End Date",
                        "uploadLoiAgreement": "Upload LOI and Agreement",
                        "informationOfOptedStorageLocation": "Information of opted location for storage ",
                        "uploadPlotImageWithTimeLocationStamp": "Upload image with date, time, and location stamp of the plot",
                        "powerConnectivity": "Power Connectivity",
                        "landFillingRequired": "Land Filling Required",
                        "yes": "Yes",
                        "no": "No",
                        "existingBoundaryFenceOrWall": "Existing boundary fence or wall",
                        "anyExistingInfraOnPlot": "Any existing infrastructure on plot",
                        "existingInfrastructure": "Existing Infrastructure",
                        "save&exit": "Save&Exit",
                        "save": "Save",
                        "preview": "Preview",
                        "enterPanNo": "Enter PAN Number",
                        "uploadPanDoc": "Upload PAN Document",
                        "addressProof": "Address Proof",
                        "enterLast4digit": "Enter last 4 digits",
                        "enterVoterId": "Enter Voter ID No",
                        "enterDrivinglicense": "Enter Driving Licence No",
                        "enterBankPassbookNo": "Enter Bank Passbook No",
                        "idProof": "ID Proof",
                        "enterIdProof": "Enter ID Proof",
                        "enterNo": "Enter No.",
                        "uploadFile": "Upload File",
                        "uploadFileTypeNote": "(upload only .png, .jpg, .jpeg, .pdf files. File size limit=5MB)",
                        "uploadPhotoOfApproachRoad": "Upload Photo showing approach road of the opted plot",
                        "mandatoryRequirements": "Mandatory Requirements",
                        "financialStrength": "Financial Strength",
                        "financialDescrip": "The applicant shall be financially sound to arrange 60-70 lacs for the project with good net worth and working capital.However, ABEPL may facilitate financing support from banks/financial institutions and other Central/State schemes etc.",
                        "mobileNetworkConnectivity": "Mobile Network Connectivity",
                        "mobileConnectivityDescrip": "The opted location should have strong network connectivity for ease of operation & communication.",
                        "environmentSustainability": "Environment and Sustainability",
                        "wildlifeCorridor": "Wildlife Corridor",
                        "wildlifeCorridorDescrip": "The opted location should not be within a wildlife corridor and should be free from habitat contiguity.",
                        "ecologicalBufferZone": "Ecological buffer zone",
                        "ecologicalBufferZoneDescrip": "The opted location should not be within 10 km of a designated ecological zone as indicated in http://moef.gov.in/rules-and-regulations/esz-notifications",
                        "forestDescrip": "The opted location should not be within 500m of forest land as designated by Govt.",
                        "soil": "Soil",
                        "soilDescrip": "The opted location should be free from risk of soil erosion.",
                        "water": "Water",
                        "waterDescrip": "The opted location should not be close to water body (seasonal or permanent).",
                        "flora&fauna": "Flora & Fauna",
                        "flora&faunaDescrip": "The opted location should not result in clearance of any endemic or threatened flora and restricted-range faunal species.",
                        "archaeologicalSite": "Archaeological Site",
                        "archaeologicalSiteDescrip": "The opted location should not be near to any archaeological site (notified by ASI) or important cultural heritage which requires preservation.",
                        "social": "Social",
                        "forcedEviction": "Forced Eviction",
                        "forcedEvictionDescrip": "The opted location should be free from any risk of forced eviction or displacement.",
                        "localEmployment": "Local Employment",
                        "localEmploymentDescrip": "The project shall strive to contribute in other ways to improve the lives of the community, such as by creating decent jobs, livelihood that help meet basic needs and add inclusive value chains.ABEPL doesn't support Forced or Child Labour.",
                        "generalTerms&Conditions": "General Terms & Conditions",
                        "termHeading": "Knowledge/Awareness of Environment, Health and Safety laws and regulations and IT Applications. ",
                        "term1": "I/We shall comply with applicable laws and regulations related to labour practices, human rights, bribery & corruption, occupational health, safety and environment and have knowledge of mobile application management.",
                        "termSubheading": "Knowledge/Awareness on bamboo resource Sustainability",
                        "term2": "I/We shall take prioritised consideration of the economic, environmental and social impacts. The applicant shall also encourage resource efficiency in the supply chain and guide stakeholders towards becoming more sustainable.",
                        "undertaking": "Undertaking",
                        "termSubheading2": "I/We have gone through the detailed advertisement, mandatory requirements and general terms and conditions as specified in this application form.",
                        "term3": "I/We hereby certify that the information given above is true to the best of my/our knowledge and belief. Any wrong information / suppression of facts will disqualify me/us from being considered for the entrepreneurship.",
                        "enterMOA": "Enter MOA No.",
                        "enterRegNo": "Enter Registration No.",
                        "enterGSTNo": "Enter GST No.",
                        "r": " ",
                        "clear": "clear",
                        "landAreaBigha": "Land Area (in Bigha)",
                        "addComment": "Add Comment",
                    },
                    "reg": {
                        "registration": "Registration",
                        "panNumber": "PAN Number",
                        "uploadIDProofDoc": "Upload ID Proof  Document",
                        "registrationDetails": "Registration Details",
                        "land": "Land",
                        "landType": "Land Type",
                        "landName": "Land Name",
                        "totalBambooQuantity": "Total Bamboo Quantity (in MT)",
                        "committedQuantity": "Committed Quantity (in MT)",
                        "actions": "Action",
                        "edit": "Edit",
                        "addNewLand": "Add New Land",
                        "addComment": "Add Comment",
                        "captive": "Captive",
                        "startDate": "Start Date",
                        "endDate": "End Date",
                        "validTill": "Valid Till",
                        "hilly": "Hilly",
                        "plain": "Plain",
                        "trench": "Trench",
                        "easeOfSourcing": "Ease of sourcing",
                        "sidingRequirement": "Siding Requirement",
                        "sidingRequirementInMeter": "Siding Requirement in Meter",
                        "distanceInMetersForLoading": "Distance in meters to the nearest vehicle motorable point for loading",
                        "sidingDistance": "Siding Distance",
                        "aggregationPoint": "Aggregation Point",
                        "aggregationPointName&Address": "Aggregation Point Name & Addres",
                        "leaseAgreement": "Lease Agreement",
                        "uploadOwnedLandDoc": "Upload Scan copy of land documents like jamabandi/ land holding certificate/ khajana receipt/declaration from village authority in case of non-cadastral land",
                        "addBambooDetails": "Add bamboo details",
                        "speciesType": "Species Type",
                        "speciesName": "Species Name",
                        "bambooSpecies": "Bamboo Species",
                        "noOfClumps": "Number of Clumps",
                        "ageOfClump": "Age of clump(in years)",
                        "avgClumpSize": "Average Clump Size",
                        "avgWeightOfBambooPole": "Average weight of bamboo pole(in Kg)",
                        "avgHeightOfBambooPole": "Average height of bamboo(in ft)",
                        "bambooPoleDiameter": "Bamboo pole diameter(in mm)",
                        "bambooPoleWallThickness": "Bamboo pole wall thickness(in mm)",
                        "annual": "Annual",
                        "monthly": "Monthly",
                        "cancel": CANCEL_POPOVER,
                        "add": ADD_POPOVER,
                        "update": UPDATE_POPOVER,
                        "addland": "Add Land",
                        "updateLand": "Update Land",
                        "getLocation": "Get Location",
                        "growerType": "Grower Type",
                        "uploadLOI&AgreementDoc": "Upload LOI and Agreement Document",
                        "uploadHarvestingPlanDoc": "Upload Other Document",
                        "addNewMember": "Add New Member",
                        "contactPersonName": "Contact Person Name",
                        "contactPersonNumber": "Contact Person Number",
                        "divisionalForestOffice": "Divisional Forest Office",
                        "forestRangeOffice": "Forest Range Office",
                        "forestBeatOffice": "Forest Beat Office",
                        "fullName": "Full Name",
                        "uploadAddressProofDoc": "Upload Address Proof Document",
                        "tradeLicenseNo": "Trade License No.",
                        "uploadTradeLicenseDoc": "Upload Transportation Trade License Document",
                        "labourLicenseNo": "Labour License No.",
                        "uploadLabourLicenseDoc": "Upload Labour License Document",
                        "uploadLast6monthsBankStatement": "Upload Last 6 Month's Bank Statement",
                        "totalVehicleCount": "Total Vehicle Count",
                        "totalManpower": "Total Manpower",
                        "addManpowerDetails": "Add Manpower Details",
                        "driverDetails": "Driver Details",
                        "harvesterDetails": "Harvester Details",
                        "vehicleDetails": "Vehicle Details",
                        "experience": "Experience",
                        "licenseNo": "License No.",
                        "trainingStatus": "Training Status",
                        "addVehicleDetails": "Add Vehicle Details",
                        "registrationNo": "Registration No.",
                        "grossWeightinKg": "Gross Weight in Kg",
                        "vehicleCapacityinKg": "Vehicle Capacity in Kg",
                        "insuranceNo": "Insurance No.",
                        "manpowerDetails": "Manpower Details",
                        "type": "Type",
                        "age": "Age",
                        "drivingLicenseNo": "Driving License No.",
                        "contactNo": "Contact No.",
                        "drivingExperienceIn": "Driving Experience in",
                        "uploadDrivingLicenseDoc": "Upload Driving License Document",
                        "years": "Years",
                        "months": "Months",
                        "driver": "Driver",
                        "harvester": "Harvester",
                        "trainingCompleted": "Training Completed",
                        "uploadTrainingCompletionDoc": "Upload Training Completion Certificate",
                        "grossVehicleWeight": "Gross Vehicle Weight in Kg",
                        "unladenWeight": "Unladen Weight in Kg",
                        "vehicleMake": "Vehicle Make",
                        "vehicleModel": "Vehicle Model",
                        "vehicleAgeInYears": "Vehicle Age in years",
                        "uploadVehicleRegistrationDoc": "Upload Vehicle Registration Document",
                        "uploadInsuranceDoc": "Upload Vehicle Insurance Document",
                        "puccNo": "PUCC No.",
                        "uploadPuccDoc": "Upload Vehicle PUCC Document",
                        "fitnessNo": "Fitness No.",
                        "uploadFitnessDoc": "Upload Vehicle Fitness Document",
                        "uploadRegistrationDoc": "Upload Registration Certificate",
                        "areasOfOperation": "Areas of Operation",
                        "area1": "Area1",
                        "area2": "Area2",
                        "area3": "Area3",
                        "area4": "Area4",
                        "area5": "Area5",
                        "area6": "Area6",
                        "area7": "Area7",
                        "area8": "Area8",
                        "addDriverDetails": "Add Driver Details",
                        "ownership": "Ownership",
                        "nationalPermit": "National Permit",
                        "permitNo": "Permit No.",
                        "uploadNationalPermitDoc": "Upload National Permit Document",
                        "uploadQualificationProofDoc": "Upload Qualification Proof",
                        "licenseDetails": "License Details",
                        "uploadTradeLicenseProofDoc": "Upload Trade License Proof",
                        "uploadResidencePrrofMoaAdhar": "Upload proof of residence (Aadhaar/ Voter ID/ Ration card/ Passport/ MOA or Registration of Society/ SHG/ Firm/ Company)",
                        "nameOfForestDivisionOffice": "Name of Forest Division Office",
                        "royaltyCharge": "Royalty Charge",
                        "otherFees": "Other Fees",
                        "fellingSeries": "Felling Series",
                        "rangeDetails": "Range Details",
                        "boundaryEast": "Boundary East",
                        "boundaryWest": "Boundary West",
                        "boundaryNorth": "Boundary North",
                        "boundarySouth": "Boundary South",
                        "forestRangeOffice": "Forest Range Office",
                        "forestRangeOfficer": "Forest Range Officer",
                        "authorizedContactNo": "Authorized Contact No.",
                        "officeAddress": "Office Address",
                        "addNewRange": "Add New Range",
                        "addNewBeat": "Add New Beat",
                        "forestBeatOffice": "Forest Beat Office",
                        "forestBeatOfficer": "Forest Beat Officer",
                        "addRange": "Add Range",
                        "addBeat": "Add Beat",
                        "updateBeat": "Update Beat",
                        "updateRange": "Update Range",
                        "beatDetails": "Beat Details",
                        "beatLandDetails": "Beat Land Details",
                        "yes2": "Yes",
                        "no2": "No",
                        "uploadLandForestMapDoc": "Land documents like govt./forest dept. classified map of the plot",
                        "forestCoupeAvailable": "Forest Coupe Available",
                        "selectCoupes": "Select Coupes",
                        "addNewFellingSeries": "Add New Felling Series",
                        "addNewCoupe": "Add New Coupe",
                        "coupeName": "Coupe Name",
                        "coupeType": "Coupe Type",
                        "coupeDetails": "Coupe Details",
                        "forestCoupeName": "Forest Coupe Name",
                        "nameOfForestCoupeOfficer": "Name of Forest Coupe Officer",
                        "uploadLandDoc": "Upload Land Documents",
                        "addCoupe": "Add Coupe",
                        "updateCoupe": "Update Coupe",
                        "dob": "Date of Birth",
                        "licenseIssuedDate": "License Issued date",
                        "validityEndDate": "Validity End date",
                        "land details": "Land Details",
                        "bamboo species details": "Bamboo Species Details",
                        "view": "View",
                        "comment": "Comment",
                        "comments": "Comments",
                        "detailsOk": "Details Ok",
                        "date": "Date",
                        "commentHistory": "Comment History",
                        "userRole": "User Role",
                        "uploadRelevantDOc": "Upload relevant documents"
                    },
                    "dashboardStakeholder": {
                        "welcomeToStakeholderDashboard": "Welcome to Stakeholder Dashboard!",
                        "pendingClarificationFromScru": "Pending Clarifications received from Scrutinizer",
                        "pendingClarificationFromResScru": "Pending Clarifications received from Resource Scrutinizer",
                        "requestSentforApproval": "Requests sent for approval",
                        "actionTaken": "Action Taken",
                        "manageWorklist": "Manage Worklist"
                    },
                    "demand": {
                        "pendingDemandNotification": "Pending Demand Notification",
                        "confirm": "Confirm",
                        "reject": "Reject",
                        "financialYear": "Financial Year",
                        "month": "Month",
                        "growerLandId": "Grower LandId",
                        "tentativeMonthlyAllocationForChipping": "Tentative Monthly Allocation for Chipping",
                        "dailyChippingCapacity": "Daily Capacity",
                        "actualDailyCapacity": "Actual Daily Capacity",
                    },
                    "payment": {
                        "paymentStatus": "Payment Status",
                        "urn": "URN",
                        "referenceNo": "Reference Number",
                        "typeOfPayment": "Type of Payment",
                        "stakeholderCategory": "Stakeholder Category",
                        "amountINR": "Amount(INR)",
                        "creationDate": "Creation Date",
                        "paymentDate": "Payment Date (if Paid)",
                        "status": "Status",
                        "bankTransactionId": "Bank Transaction Id",
                        "liv Number": "Liv Number",
                    },
                    "resource": {
                        "viewKnowledgeManagement": "View Knowledge Management",
                        "documentName": "Document Name",
                        "stakeholderType": "Stakeholder Type",
                        "viewDocument": "View Document",
                        "downloadDocument": "Download Document",
                        "view": "View",
                        "download": "Download",
                        "createPlantationBatch": "Create Plantation Batch",
                        "viewPlantationBatch": "View/Update Plantation Batch",
                        "proceed": "Proceed",
                        "selectLandToCreatePlantation": "Select a land to create Plantation Batch",
                        "growerURN": "Grower URN",
                        "growerName": "Grower Name",
                        "add": "Add species",
                        "edit": "Edit species",
                        "saplingType": "Sapling Type",
                        "otherSaplingType": "Other sapling type",
                        "saplingQuantity": "Sapling Quantity",
                        "saplingSource": "Sapling Source",
                        "otherSaplingSource": "Other sapling source",
                        "spacingLength": "Spacing Length(in Mt)",
                        "spacingWidth": "Spacing Width(in Mt)",
                        "noDataAvailable": NO_DATA_AVAILABLE,
                        "dateOfNewPlantation": "Date of New Plantation",
                        "plantationMaturedDate": "Plantation Matured Date",
                        "uploadPhotos": "Upload photos",
                        "uploadDocument": "Upload Document",
                        "chooseFile": "Choose File",
                        "species": "Species",
                        "urn": "URN",
                        "getPlantationDetails": "Get Plantation Details",
                        "plantationBatch": "Plantation Batch",
                        "dateOfPlantation": "Date of Plantation",
                        "averageBambooPoleWeightinKg": "Average Bamboo Pole Weight(in Kg)",
                        "totalLandArea(in Bigha)": "Total Land Area(in Bigha)",
                        "availableLandArea(in Bigha)": "Available Land Area(in Bigha)",
                        "existingLandArea(in Bigha)": "Existing Land Area(in Bigha)",
                        "plantationBatchNo": "Plantation Batch No."
                    },
                    "helpdesk": {
                        "newIncident": "New Incident",
                        "newExternalIncident": "New External Incident",
                        "dontHaveAnyTicket": "You don't have any ticket under this option!!",
                        "id": "ID",
                        "subject": "Subject",
                        "requesterName": "Requester Name",
                        "requestedBy": "Requested By",
                        "requestedFor": "Requested For",
                        "supportExecutive": "Support Executive",
                        "category": "Category",
                        "subCategory": "Sub-Category",
                        "status": "Status",
                        "dueByDate": "Due By Date",
                        "createdDate": "Created Date",
                        "edit": "Edit",
                        "userId": "User ID",
                        "userName": "User Name",
                        "contactNo": "Contact Number",
                        "urn": "URN",
                        "requesterUrnEmail": "Requester URN/Email",
                        "requestType": "Request Type",
                        "select": "Select",
                        "save": "Save",
                        "helpTopics": "Help Topics",
                        "createTicket": "Create a ticket",
                        "stillNotSatisfied": "Still not satisfied?",
                        "satisfied": "Satisfied",
                        "description": "Description",
                        "updateRequesterDetails": "Update Requester Details",
                        "searchByContact": "Search by contact",
                        "searchByUrn": "Search by URN",
                        "searchByEmail": "Search by Email",
                        "or": "OR",
                        "stakeholder": "Stakeholder",
                        "guest": "Guest",
                        "addRequesterUrn": "Add Requester URN",
                        "addRequesterEmail": "Add Requester Email",
                        "addRequesterContact": "Add Requester Contact Number",
                        "addGuestContact": "Add Guest Contact Number",
                        "searchByGuestContact": "Search by Guest Contact",
                        "dontHaveValidDetails": "Don't have valid details?",
                        "applyAsNewGuest": "Apply As New Guest",
                        "noFaqFound": "No FAQ Found !",
                        "uploadYourFileHere": "Upload your file here",
                        "browse": "Browse",
                        "supportedFile": "supported files:pdf,png.",
                        "grievanceResolution": "Grievance Resolution",
                        "ticketNumber": "Ticket Number",
                        "priority": "Priority",
                        "sla": "SLA",
                        "noDescriptionAvailable": "No Description Available",
                        "attachments": "Attachments",
                        "worklogs": "Worklogs",
                        "addComment": "Add Comment",
                        "comment": "Comments",
                        "changedBy": "Changed By",
                        "changedTimestamp": "Changed Timestamp",
                        "faqs": "FAQs",
                        "faqDownload": "FAQs Download",
                        "newWorklog": "New Worklog",
                    },
                    "pit": {
                        "poList": "PO List",
                        "soList": "SO List",
                        "stoList": "STO List",
                        "scoList": "SCO List",
                        "poDate": "PO Date",
                        "soDate": "SO Date",
                        "stoDate": "STO Date",
                        "scoDate": "SCO Date",
                        "poNo": "PO Number",
                        "planningNo": "Planning Number",
                        "year": "Year",
                        "month": "Month",
                        "stakeholderName": "Stakeholder Name",
                        "stakeholderUrn": "Stakeholder URN",
                        "quantity": "Quantity",
                        "ActualQuantity": "Actual Quantity (MT)",
                        "ExpectedQuantity": "Expected Quantity (MT)",
                        "poQuantity": "PO Quantity",
                        "balanceQuantity": "PO Balance Quantity (MT)",
                        "soQuantity": "SO Quantity",
                        "soBalanceQuantity": "SO Balance Quantity (MT)",
                        "stoQuantity": "STO Quantity",
                        "stoBalanceQuantity": "STO Balance Quantity (MT)",
                        "scoQuantity": "SCO Quantity",
                        "scoBalanceQuantity": "SCO Balance Quantity (MT)",
                        "view": "View",
                        "growerPo": "Grower PO",
                        "vendorDetails": "Vendor Details",
                        "name": "Name",
                        "urn": "URN",
                        "contactPerson": "Contact Person",
                        "phoneNumber": "Phone Number",
                        "address": "Address",
                        "lineNo": "Line No",
                        "itemCode": "Item Code",
                        "itemDesc": "Item Desc",
                        "itemType": "Item Type",
                        "uom": "UOM",
                        "shipTo": "Ship to (Name & Address)",
                        "billTo": "Bill to (Name & Address)",
                        "deliveryDate": "Delivery Date",
                        "validityDate": "Validity Date",
                        "price": "Price (INR)",
                        "cgst": "CGST (INR)",
                        "sgst": "SGST (INR)",
                        "igst": "IGST (INR)",
                        "total": "Total (Exc. Taxes) (INR)",
                        "customerDetails": "Customer Details",
                        "download": "Download",
                        "print": "Print",
                        "weeklyPickupPlan": "Weekly Pick-Up Plan",
                        "scheduleFrom": "Scheduled From",
                        "scheduleTo": "Scheduled To",
                        "scheduleNo": "Schedule Number",
                        "scheduleLineNo": "Schedule Line No.",
                        "pickUpDate": "Pick up Date",
                        "urn1stParty": "URN(1stParty)",
                        "contactDetails1stParty": "Contact Details(1stParty)",
                        "location1stParty": "Location(1stParty)",
                        "urn2ndParty": "URN(2ndParty)",
                        "contactDetails2ndDetails": "Contact Details(2ndParty)",
                        "location2ndParty": "Location(2ndParty)",
                        "landId": "Land ID",
                        "typeOfInventory": "Type of Inventory",
                        "approvalStatus": "Approval Status",
                        "harvestingDetails": "Harvesting Details",
                        "invoiceList": "Invoice List",
                        "pending": "Pending",
                        "accepted": "Accepted",
                        "rejected": "Rejected",
                        "invoiceType": "Invoice Type",
                        "date": "Date",
                        "status": "Status",
                        "approve": "Approve",
                        "accept": "Accept",
                        "reject": "Reject",
                        "growerInvoice": "Grower Invoice",
                        "invoiceNo": "Invoice Number",
                        "invoiceDate": "Invoice Date",
                        "vendorName": "Vendor Name",
                        "consignment": "Consignment Number",
                        "invoiceType": "Invoice Type",
                        "gstIn": "GSTIN",
                        "orderDetails": "Order Details",
                        "orderNo": "Order Number",
                        "orderDate": "Order Date",
                        "shippingDetails": "Shipping Details",
                        "shippingDate": "Shipping Date",
                        "shippedByName": "Shipped By (Name)",
                        "shippedByPhone": "Shipped By (Phone)",
                        "acknowledgmentId": "Acknowledgement ID",
                        "unitPer": "UnitPer",
                        "amount": "Amount (INR)",
                        "sumTotal": "Sum Total",
                        "ItemDescHSNCode": "Item Desc/HSN Code",
                        "consignmentList": "Consignment List",
                        "consignmentCreation": "Consignment Creation",
                        "consignmentNo": "Consignment No.",
                        "consignmentStatus": "Consignment Status",
                        "deliveryChallanNo": "Delivery Challan No.",
                        "challanNo": "Challan No.",
                        "deliveryChallanDate": "Delivery Challan Date",
                        "sourceUrn": "Source URN",
                        "sourceLocation": "Source Location",
                        "destinationUrn": "Destination URN",
                        "destinationLocation": "Destination Location",
                        "vehicleNo": "Vehicle No.",
                        "consignmentDetails": "Consignment Details",
                        "consignmentOwnerUrn": "Consignment Owner URN",
                        "schedulePickupDate": "Schedule Pick-Up Date",
                        "vehicleRegistration": "Vehicle Registration",
                        "consignmentOwnerName": "Consignment Owner Name",
                        "scheduleConsignmentWeight": 'Schedule consignment Weight (MT)',
                        "deliveryLocationUrn": "Delivery Location URN",
                        "consignmentOwnerContact": "Consignment Owner Contact",
                        "deliveryLocationName": "Delivery Location Name",
                        "tareWeightMeasureLle": "Tare weight measured @ LLE",
                        "pickupLocationUrn": "Pick-Up Location URN",
                        "deliveryLocationAddress": "Delivery Location Address",
                        "averageMoistureDuringPickup": "Average Moisture during the pickup",
                        "pickupLocationName": "Pick-Up Location Name",
                        "grossWeightMeasuredLle": "Gross weight measured @ LLE",
                        "pickupLocationAddress": "Pick-Up Location Address",
                        "typeOfLoading": "Type Of Loading(FTL/LTL)",
                        "weightDuringPickup": "Weight during pickup (in MT)",
                        "sto": "STO",
                        "sco": "SCO",
                        "driverName": "Driver Name",
                        "weightDuringPickupFromBundleSelection": "Weight during pickup from Bundle selection(in MT)",
                        "driverLicenseNo": "Driver License No.",
                        "odometerStartReading": "Odometer Start Reading",
                        "scheduleDeliveryDate": "Schedule Delivery Date",
                        "scheduleDate": "Schedule Date",
                        "driverContact": "Driver Contact",
                        "firstPartyDetails": "First Party Details",
                        "firstPartyUrn": "FirstParty URN",
                        "firstPartyLocName": "First Party Loc Name",
                        "firstPartyLocAddress": "FirstParty Loc Address",
                        "secondPartyDetails": "Second Party Details",
                        "grossWeightInMT": "Gross weight (in MT) measured",
                        "tareWeightInMT": "Tare weight (in MT) measured",
                        "netWeightInMT": "Net weight(in MT) as per measurement",
                        "averageMoisture": "Average Moisture",
                        "DeviationWeightPer": "Deviation Weight(in %)",
                        "deviationMoisturePer": "Deviation Moisture(in %)",
                        "invoiceDetails": "Invoices Details",
                        "invoiceAmount": "Invoice Amount (Exc. Taxes) (INR)",
                        "urn": "URN",
                        "stoNo": "STO Number ",
                        "scoNo": "SCO Number ",
                        "servicePo": "Service PO",
                        "soNo": "SO Number",
                        "destination stakeholder type": "Destination Type",
                        "destination stakeholder URN": "Destination URN",
                        "short close": "Short Close",
                        "short close qty": "Short Close Quantity",
                        "current Owner": "Current Owner",
                        "received qty": "Received Quantity",
                        "scheduled quantity": "Scheduled Quantity",
                        "Modified PO Quantity": "Modified PO Quantity (MT)",
                        "Modified SO Quantity": "Modified SO Quantity (MT)",
                        "Modified STO Quantity": "Modified STO Quantity (MT)",
                        "Modified SCO Quantity": "Modified SCO Quantity (MT)",
                        "update": "Update",
                        "PO Pending List": "PO Pending List",
                        "SO Pending List": "SO Pending List",
                        "STO Pending List": "STO Pending List",
                        "SCO Pending List": "SCO Pending List",
                        "PO Approved List": "PO Approved List",
                        "SO Approved List": "SO Approved List",
                        "STO Approved List": "STO Approved List",
                        "SCO Approved List": "SCO Approved List",
                        "Modified PO": "Modified PO",
                        "Modified SO": "Modified SO",
                        "Modified STO": "Modified STO",
                        "Modified SCO": "Modified SCO",
                        "Pending Modified PO List": "Pending Modified PO List",
                        "Pending Modified SO List": "Pending Modified SO List",
                        "Pending Modified STO List": "Pending Modified STO List",
                        "Pending Modified SCO List": "Pending Modified SCO List",
                        "Approved Modified PO List": "Approved Modified PO List",
                        "Approved Modified SO List": "Approved Modified SO List",
                        "Approved Modified STO List": "Approved Modified STO List",
                        "Approved Modified SCO List": "Approved Modified SCO List",
                        "To be modified PO": "To be modified PO",
                        "To be modified SO": "To be modified SO",
                        "To be modified STO": "To be modified STO",
                        "To be modified SCO": "To be modified SCO",
                        "Unit Price": "Unit Price (INR)",
                        "Total Amount": "Total Amount (INR)",
                        "delete": "Delete",
                        "edit": "Edit",
                        "cancellationComment": "Cancellation Comment",
                        "consignmentCancel": 'Cancel Consignment',
                        "cancelHeader": 'Are you sure you want to cancel this consignment? Please provide a reason below.',
                        "cancellationReason": 'Cancellation Reason',
                        "Commentmandatory": 'Comment is mandatory for cancellation.'
                    },
                    "sidebarStakeholder": {
                        "dashboard": "Dashboard",
                        "helpdesk": "HelpDesk",
                        "requests": "Requests",
                        "faqs": "FAQs",
                        "demand": "Demand",
                        "pit": "PIT",
                        "po": "PO",
                        "weeklySchedule": "Weekly Schedules",
                        "invoices": "Invoices",
                        "consignmentList": "Consignment List",
                        "paymentStatus": "Payment Status",
                        "registrationDetails": "Registration Details",
                        "resource": "Resource",
                        "viewKnowledgeManagement": "View Knowledge Management",
                        "plantationBatch": "Plantation Batch",
                        "userOnboarding": "User Onboarding"
                    },
                    "account": {
                        "upload photo": "Upload Photo",
                        "change password": "Change Password",
                        "logout": "Logout",
                    }
                }
            },
            as: {
                translation: {
                    "main": {
                        "header": "এ বি ই পি এল ডিজিটেল বাাঁহ যোগান শৃংখলা প্লেটফৰ্ম",
                        "home": "মূখ্যপৃষ্ঠা",
                        "about": "সবিশেষ",
                        "aboutUs": " আমাৰ বিষয়ে",
                        "services": "সেৱাসমূহ",
                        "portfolio": "নথিপত্ৰ",
                        "contact": "যোগাযোগ",
                        "login": "লগইন",
                        "register": "পঞ্জীয়ন",
                        "copyright": "অসম বায়' ইথানল প্ৰাইভেট লিমিটেড। সকলো অধিকাৰ সংৰক্ষিত.",
                        "sitemap": "চাইটমেপ",
                        "contactDetails": "যোগাযোগৰ সবিশেষ",
                        "address": "ঠিকনা",
                        "abeplLogin": "এ বি ই পি এল লগইন",
                        "userLogin": "অন্যান্য লগইন",
                        "welcome": "লৈ স্বাগতম",
                        "abepl": "এ বি ই পি এল",
                        "readmore": "অধিক পঢ়ক",
                        "news": "এ বি ই পি এল বাতৰি",
                        "newsContent": NEWS_CONTENT,
                        "status": "আবেদনৰ স্থিতি নিৰীক্ষণ কৰক",
                        "check": "স্থিতি নিৰীক্ষণ কৰক",
                        "para1": `অসম বায়' ইথানল প্ৰাইভেট লিমিটেড (এবিইপিএল) বাঁহৰ জৈৱ ভৰৰ পৰা ইন্ধন সম ইথানল উৎপন্ন কৰা প্ৰথম জৈৱ ইথানল । এবিইপিএল যোৱা ০৪-০৬-২০১৮ ত নুমলীগড় ইথানল লিমিটেড আৰু দুটা ফিনীছ্ কোম্পানী ফ'ৰটাম বি ভি আৰু চেম্পলিছ অ' ওৱাই ৰ মাজত এক সংযুক্ত উদ্যম কোম্পানী হিচাপে পঞ্জীকৃত হৈছে। ইথানলটোৰ কাৰ্য্যালয় অসমৰ গোলাঘাট জিলাৰ নুমলীগড়ত অৱস্থিত । ইথানলটোৰ বাৰ্ষিক উৎপাদন ক্ষমতাৰ হাৰ - ইথানল- ৪৮৯০০ মেট্ৰিকটন, ফাৰফিউৰেল- ১৯০০০ মেট্ৰিকটন, এচেটিক এচিড- ১১০০০ মেট্ৰিকটন, আৰু ৩১০০০ মেট্ৰিকটন খাদ্য উপযোগী তৰল কাৰ্বন-ডাই-অ’ক্সাইড ।`,
                        "para2": `এবিইপিএল বাঁহ খেতিয়কসকলৰ অতিৰিক্ত উপাৰ্জন, কুশলগত/দক্ষ  সংগ্ৰাহক সকলৰ বাবে ৰোজগাৰৰ সৃষ্টি, উদ্যোগিক ব্যৱস্থাপনাৰ জৰিয়তে গ্ৰাম্য অৰ্থনীতিৰ বিকাশ  আৰু গ্ৰীন হাউছ গেছ ৰ নিৰ্গমণ হ্ৰাস কৰাৰ দৰে অৰ্থনৈতিক, সামাজিক আৰু পৰিবেশ  সম্বন্ধীয় উদ্দেশ্যসমূহৰ দ্বাৰা সঞ্চালিত ।`,
                        "para3": `বাঁহ হ'ল ইথানলটোৰ বাবে মূল কেঁচাসামগ্ৰী যাৰ বাৰ্ষিক উপভোগ ক্ষমতা/সেৱন ক্ষমতা ৫০০ টিএমটি কেঁচা বাঁহৰ (৩০০ টিএমটি শুকান বাঁহৰ সমপৰিমাণৰ) সমান হ'ব পাৰে, যিবোৰ আৰ্থিক ক্ষেত্ৰৰ ভিতৰৰ  চিহ্নিত  বাঁহ উৎপাদিত অঞ্চলসমূহৰ পৰা লোৱা হ'ব । এবিইপিএল এ স্বতন্ত্ৰ বাঁহ খেতিয়কসকলৰ লগতে বাঁহ খেতিয়কৰ গোটসমূহৰ পৰা প্ৰত্যক্ষভাৱে বাঁহ আহৰণৰ এক সুকীয়া আৰু অভিলাষী সৰবৰাহ/যোগান শৃংখলা আৰ্হিৰ নিৰূপণ আৰু বিকাশ কৰিছে । সেই অনুক্ৰমে, এবিইপিএল ৰ উৎপাদন ক্ষেত্ৰৰ মাজত বিস্তাৰিত হৈ থকা অনুকুল স্থানসমূহত বিকেন্দ্ৰীকৃত একত্ৰীকৰণ আৰু সংস্কৰণ কেন্দ্ৰ চিনাক্ত কৰা হৈছে য'ত  সংগৃহীত বাঁহ এক নিৰ্ধাৰিত অঞ্চলৰ মাজত থকা খেতিয়কসকলৰ পৰা আহৰণ কৰা হ'ব । এই কেন্দ্ৰসমূহত গোটা বাঁহবোৰ প্ৰয়োজন অনুসৰি প্ৰায় ১ ইঞ্চি দীঘ-পুতল জোখৰ বাঁহৰ টুকুৰালৈ ৰূপান্তৰিত কৰা হ'ব । এইদৰে সৃষ্টি কৰা  বাঁহৰ টুকুৰাবোৰ তাৰ পিছত বায়’ইথানল আৰু অন্যান্য সামগ্ৰী প্ৰস্তুত কৰিবলৈ পুণৰ প্ৰক্ৰিয়াকৰণৰ বাবে ইথানললৈ প্ৰেৰণ কৰা হয় । `,
                        "para4": `এবিইপিএল কেৱল সৰবৰাহ/যোগান শৃংখলাৰ অন্তৰ্ভুক্ত সকলো হিতাধিকৰীৰ আভ্যন্তৰীণ বিকাশৰ প্ৰতিয়েই দায়বদ্ধ নহয়, অথচ এবিইপিএল এ বিভিন্ন চৰকাৰী খণ্ডৰ দ্বাৰা হোৱা ৰোপণ কাৰ্য, খেতিয়কসকলৰ বাবে ঋণ সংযোজন, আৰু কলা সংবৰ্ধনৰ দ্বাৰা উৎপাদিত পুলিবোৰ উচ্চমানৰ ৰোপণ সামগ্ৰী হিচাপে উপলবদ্ধ কৰা ইত্যাদি কামত সহায় কৰি সংগৃহীত বাঁহৰ পৰিপূৰ্ণতাৰ দায়িত্বও বহন কৰে । এইদৰে এবিইপিএল এ অন্তঃত এক বহনক্ষম সৰবৰাহ/যোগান শৃংখলা পৰিস্থিতি তন্ত্ৰ সৃষ্টি কৰিব বিচাৰে য’ত মানুহ, পৰিবেশ আৰু অৰ্থনীতি এক পৰ্য্যাপ্ত  ৰূপত বিকশিত হয় । `,
                        "one": '১',
                        "two": "২",
                        "three": "৩",
                        "four": "৪",
                        "five": "৫",
                        "farmersTitle": "বাঁহ খেতিয়ক",
                        "farmersContent": "এওঁলোক অধিস্থিত বাঁহ উৎপাদন গোট সমূহৰ অধিকাৰী যিয়ে প্ৰত্যক্ষভাৱে এবিইপিএল ক বাঁহ যোগান ধৰিব পাৰে আৰু সৰবৰাহৰ সময়ৰ প্ৰচলিত হাৰ অনুযায়ী সৰবৰাহিত বাঁহৰ পৰিমাণ অনুসৰি তেওঁলোকৰ পঞ্জীকৃত বেংক খাতাত ইলেক্ট্ৰনিক আদায় (ই-পেমেণ্ট) লাভ কৰে ।  ",
                        "hitTitle": "সংগ্ৰাহক ও মধ্যকালীন পৰিবাহক",
                        "hitContent": "এওঁলোক উৎপাদন স্থলীত বাঁহৰ বহনক্ষম সংগ্ৰহ , সেইবোৰ চিকুণাই গোটা বাঁহলৈ পৰিৱৰ্তন কৰা, সঠিক মাপত খণ্ডীকৰণ কৰা, বাঁহৰ আটি সজা আৰু ওজন কৰা আৰু সেইবোৰ নিকটতম বাঁহ একত্ৰীকৰণ তথা প্ৰক্ৰিয়াকৰণ কেন্দ্ৰসমূহলৈ প্ৰেৰণ কৰাৰ বাবে দায়বদ্ধ । ",
                        "lleTitle": "স্থানীয় উদ্যোক্তা",
                        "lleContent": "এওঁলোক একত্ৰীকৰণ তথা প্ৰক্ৰিয়াকৰণ কেন্দ্ৰসমূহৰ মালিকীস্বত্ত্ব আৰু পৰিচালনাৰ বাবে দায়বদ্ধ , য’ত  সংগ্ৰাহক ও মধ্যকালীন পৰিবাহক সকলৰ পৰা লাভ কৰা বাঁহবোৰ সঠিকভাৱে সংৰক্ষণ কৰা হয় আৰু সেইবোৰ উচ্চমানৰ সঠিক মাপৰ টুকুৰালৈ ৰূপান্তৰ কৰা হয় । ",
                        "transporterTitle": "পৰিবাহক",
                        "transporterContent": "এওলোক বাঁহৰ সৰু টুকুৰাবোৰ বিভিন্ন স্থানীয় উদ্যোক্তাৰ ক্ষেত্ৰসমূহৰ পৰা এবিইপিএলৰ কাৰ্য্যালয় সমূহলৈ পুণৰ প্ৰক্ৰিয়াকৰণৰ বাবে প্ৰেৰণ কৰাৰ বাবে দায়বদ্ধ । ",
                        "terms": "ব্যৱহাৰৰ চৰ্তাৱলী",
                        "privacy": "গোপনীয়তা নীতি",
                        "copyright": "স্বত্বাধিকাৰ",
                        "allrightsReserved": "সকলো অধিকাৰ সংৰক্ষিত",
                        "officeAddressTitle": "পঞ্জীভুক্ত কাৰ্যালয় ঠিকনা",
                        "siteOfficeTitle": "স্থানীয় কাৰ্যালয়ৰ ঠিকনা",
                        "contactNos": "যোগাযোগৰ নম্বৰ",
                        "abeplName": "অসম বায়' ইথানল প্ৰাইভেট লিমিটেড",
                        "abeplAdd1": "এন.আৰ.এল. বিল্ডিং, 122A, জি.এছ.ৰোড",
                        "abeplAdd2": "খ্ৰীষ্টানবস্তি, গুৱাহাটী, অসম, ভাৰত",
                        "abeplpin": "পিন - ৭৮১০০৫",
                        "email": "ই-মেইল",
                        "siteAdd1": "ডাক ব’ক্স: ০০৩, ডাকঘৰ: এন.আৰ.প্ৰজেক্ট",
                        "siteAdd2": "জিলা: গোলাঘাট, অসম, ভাৰত",
                        "sitepin": "পিন - ৭৮৫৬৯৯",
                        "siteContact": "যোগাযোগ নং: +৯১ ৩৭৭৬ ২৮১০১৫ (সময়: পুৱা ৮ বজাৰ পৰা বিয়লি ৫ বজালৈ)",
                        "contact1": "ড° প্ৰণৱ কুমাৰ নাথ- +৯১ ৮৬৩৮৬১৬৬৭২",
                        "contact2": "শ্ৰী যুত হিদম টনছানা- +৯১ ৭৪২৮৬৯৬৬১৬",
                        "contact3": "শ্ৰী যুত মাছুদ ইক্‌বাল- +৯১ ৮৮১১০৩৫১৬২",
                        "contact4": "শ্ৰী যুত তন্ময় চুটীয়া- +৯১ ৯৬৪৩১৪৮৪৫২",
                        "title": "অসম বায়'ইথানল প্ৰাইভেট লিমিটেড",
                        "footer": "অসম বায়' ইথানল প্ৰাইভেট লিমিটেড। সকলো অধিকাৰ সংৰক্ষিত।"
                    },
                    // "admin": {
                    //     "registeredStakeholders": "পঞ্জীভুক্ত অংশীদাৰ",
                    //     "activeApplications": "সক্ৰিয় দৰ্খাস্তসমূহ",
                    //     "newRegistrations": "নতুন পঞ্জীয়ন",
                    //     "shortlisted": "সংক্ষিপ্ত তালিকাভুক্ত",
                    //     "waitlisted": "অপেক্ষাত ৰখা হৈছে ",
                    //     "issueRaised": "উত্থাপিত সমস্যাসমূহ",
                    //     "comingSoon": "সোনকালে আহিব !!!!",
                    //     "upcomingTasks": "আগন্তুক কাৰ্য্যসমূহ",
                    //     "manageScrutiniser": "নিৰীক্ষণকাৰী ব্যৱস্থাপনা কৰক",
                    //     "pendingTasks": "অমীমাংসিত কাৰ্য্যসমূহ",
                    //     "mapView": "মানচিত্ৰ দৰ্শন",
                    //     "viewAll": "View all",
                    //     "helpdesk": "হেল্পডেস্ক",
                    //     "quality": "মানদণ্ড",
                    //     "dashboard": "ডেশ্বব'ৰ্ড",
                    //     "pit": "পি আই টি",
                    //     "registration": "পঞ্জীয়ন",
                    //     "demand": "Demand",
                    //     "payment": "Payment",
                    //     "welcome": "স্বাগতম",
                    //     "signOut": "ছাইন আউট কৰক"
                    // },
                    "preReg": {
                        "enterMobileNoOrUrn": "মোবাইল নং/ইউ আৰ এন দাখিল কৰক",
                        "imNotRobot": "মই ৰ’বট নহয়",
                        "heading": "হিতাধিকাৰী প্ৰাক-পঞ্জীয়ন",
                        "subheading": "হিতাধিকাৰীৰ এক শ্ৰেণী নিৰ্বাচন কৰক",
                        "transporter": "পৰিবাহক",
                        "lle": "এল এল ই",
                        "lleSub": "স্থানীয় পৰ্যায়ৰ উদ্যোক্তা",
                        "hit": "এইচ আই টি",
                        "hitSub": "উৎপাদন ও মধ্যকালীন পৰিবাহক ",
                        "grower": "উৎপাদক",
                        "growerSub": "উৎপাদক সকলৰ উপশ্ৰেণীবোৰ জেএফএমচি, এচএইচ্‌জি, ফ’ৰেষ্ট, এফপিঅ’,এফপিচি, সমবায় আৰু আন প্ৰতিষ্ঠান",
                        "intrimStorage": "মধ্যকালীন সংৰক্ষণাগাৰ পৰিচালক",
                        "individual": "স্বতন্ত্ৰ",
                        "fpo": "এফ পি অ’",
                        "fpc": "এফ পি চি",
                        "jfmc": "জে এফ এম চি ",
                        "forest": "বন ",
                        "shg": "এচ এইচ্ ‌জি",
                        "cooperative": "সমবায়",
                        "enterprise": "উদ্যোগ",
                        "subCategorySelection": "উপশ্ৰেণী নিৰ্বাচন কৰক",
                        "pre-registration": "পূৰ্ব-পঞ্জীকৰণ",
                        "name": "নাম",
                        "personalDetails": "ব্যক্তিগত বিৱৰণ",
                        "organizationDetails": "সংগঠনৰ সবিশেষ",
                        "salutation": "শ্ৰী/শ্ৰীমতী",
                        "firstname": "প্ৰথম নাম",
                        "middlename": "মধ্য নাম",
                        "lastname": "উপাধি ",
                        "gender": "লিংগ",
                        "mobileNo": "ম'বাইল নম্বৰ",
                        "otp": "অ টি পি",
                        "permanentAddress": "স্থায়ী ঠিকনা",
                        "bambooDetails": "বাঁহৰ বিৱৰণ",
                        "totalPlotArea": "মুঠ ভূমিখণ্ডৰ মাটিকালি",
                        "totalClumps": "মুঠ খণ্ডৰ সংখ্যা",
                        "plotAddress": "ভূমিখণ্ডৰ ঠিকনা",
                        "pincode": "পিনক’ড",
                        "state": "ৰাজ্য",
                        "district": "জিলা",
                        "revenueBlock": "ৰাজহ চক্ৰ/খণ্ড কাৰ্যালয়",
                        "revenueCircle": "ৰাজহ চক্ৰ",
                        "blockOffice": "খণ্ড",
                        "sameasPermanentAdd": "স্থায়ী ঠিকনাৰ সৈতে একে",
                        "sameasRegisteredAdd": "পঞ্জীয়নভুক্ত ঠিকনাৰ দৰেই",
                        "applicantType": "আবেদনকাৰীৰ প্ৰকাৰ",
                        "partnership": "অংশীদাৰিত্ব",
                        "proprietorship": "স্বত্বাধিকাৰ",
                        "pvtLtdCompany": "প্ৰাইভেট লিমিটেড বাণিজ্যিক সংগঠন/প্ৰতিষ্ঠান",
                        "applicantName": "আবেদনকাৰীৰ নাম",
                        "contactPersonDetails": "যোগাযোগ ব্যক্তিৰ বিৱৰণ",
                        "contactDetails": "যোগাযোগ বিৱৰণ",
                        "registeredAddress": "পঞ্জীয়নভুক্ত ঠিকনা",
                        "contactPerson": "যোগাযোগ ব্যক্তি",
                        "submit": "দাখিল কৰক",
                        "r": "ৰ",
                        "firm": "প্ৰতিষ্ঠান",
                        "company": "বাণিজ্যিক সংগঠন",
                        "next": "পৰৱৰ্তী",
                        "vehicleDetails": "বাহনৰ বিৱৰণ",
                        "vehicleType": "বাহনৰ প্ৰকাৰ",
                        "ownedVehicle": "ব্যক্তিগত বাহন",
                        "rentedVehicle": "ভাৰাতীয়া বাহন",
                        "lcv": "পাতল বাণিজ্যিক বাহন",
                        "hcv": "গধুৰ বাণিজ্যিক বাহন",
                        "mcv": "মজলীয়া বাণিজ্যিক বাহন",
                        "areasOfOperation": "কাৰ্যকৰী ক্ষেত্ৰ",
                        "previous": "পূৰ্ব্ববৰ্তী",
                        "applicantGeneralInfo": "আবেদনকাৰীৰ সাধাৰণ তথ্য",
                        "qualification": "অৰ্হতা",
                        "highestQualification": "সৰ্বোচ্চ শিক্ষাগত অৰ্হতা",
                        "credentials": "প্ৰত্যয়জনক তথ্য",
                        "typeOfBusinessOccupation": "ব্যৱসায়/বৃত্তিৰ শ্ৰেণী",
                        "financialInformation": "আৰ্থিক তথ্য",
                        "networth": "মুঠ আৱণ্টিত ধনৰাশি",
                        "inINR": "(টকা)",
                        "workingCapital": "কাৰ্য্কৰী মূলধন",
                        "optedChippingLocationDetails": "খণ্ডীকৰণ গোট খোলাৰ বাবে উক্ত/নিৰ্বাচিত অৱস্থানৰ বিৱৰণ",
                        "landArea": "ভূমিৰ মাটিকালি",
                        "existingLandArea": "বিদ্যমান ভূমি ক্ষেত্ৰ",
                        "availableLandArea": "উপলব্ধ ভূমি ক্ষেত্ৰ",
                        "estimatedBambooAvailability": "বাঁহৰ আনুমানিক উপলব্ধতা",
                        "within4050radius": "(৪০-৫০ কি.মি. ব্যাসাৰ্ধ ভিতৰত)",
                        "quantity": "পৰিমাণ (এম টি)",
                        "informationAboutOptedLocation": "উক্ত/নিৰ্বাচিত অৱস্থানৰ বিষয়ে তথ্য",
                        "applicantPermanentResidence": "কাৰ্যকৰী ক্ষেত্ৰৰ ভিতৰত আবেদনকাৰীৰ স্থায়ী বাসগৃহ",
                        "within25km": "উক্ত জিলাৰ নিৰ্বাচিত স্থানৰ পৰা ২৫ কিমি ৰ ভিতৰত",
                        "beyond25km": "২৫ কিমি অতিক্ৰম কৰা কিন্তু নিৰ্বাচিত স্থানৰ একেখন জিলা ",
                        "adjacentDistrict": "নিকটৱৰ্তী জিলাৰ পৰা",
                        "otherDistrict": "ৰাজ্য খনৰ অন্য জিলাৰ পৰা",
                        "availabilitOfLandForChippingUnit": "খণ্ডীকৰণ গোটৰ বাবে ভূমিক্ষেত্ৰৰ উপলব্ধতা",
                        "ownOrlease": "(ব্যক্তিগত অথবা লীজত লোৱা)",
                        "morethan4bighas": "৪ বিঘাতকৈ বেছি ",
                        "between3to4bighas": "৩-৪ বিঘাৰ ভিতৰত",
                        "optedLandDescript": "উক্ত ক্ষেত্ৰ কৃষিভূমি নহয় আৰু চিকিৎসালয়, শিক্ষানুষ্ঠান, আদালত, ধাৰ্মিক অনুষ্ঠান আদিৰ পৰা অতি কমেও ৫০০ মিটাৰ দূৰত্বত অৱস্থিত । ভূমিক্ষেত্ৰ বানপানী আৰু জলাবদ্ধতাৰ পৰা মুক্ত হোৱা উচিত ।",
                        "ownnershipType": "মালিকীস্বত্বৰ প্ৰকাৰ",
                        "owned": "ব্যক্তিগত",
                        "lease": "লীজত লোৱা",
                        "rented": "ভাড়াত লোৱা",
                        "uploadUdyamCertificate": "(উদ্যম পত্ৰৰ প্ৰতিলিপি/ উপযুক্ত সমৰ্থনকাৰী নথিপত্ৰ সংলগ্ন কৰক)",
                        "uploadProofOfResidence": "বাসগৃহৰ প্ৰমাণপত্ৰ আপল’ড কৰক",
                        "uploadJamabandiKhajnaTax": "জমাবন্দী/খাজনা বা কৰ আদায়কাৰী ৰছিদ আপল’ড কৰক",
                        "uploadJamabandiReceiptLandOwnerTax": "জমাবন্দী/খাজনা অথবা মাটিৰ মালিকৰ কৰ আদায়কাৰী ৰছিদ/ মাটিৰ মালিকৰ সৈতে কৰা চুক্তিপত্ৰ আপল'ড কৰক",
                        "roadConnectivity": "উক্ত/নিৰ্বাচিত ভূমিখণ্ডৰ পথ সংযোগকাৰিতা",
                        "roadConnectivityDescrip": "অতি কমেও ১৮ টন ভৰ ক্ষমতা যুক্ত ডাঙৰ মালবাহী ট্ৰাক চলাচলৰ বাবে পথটো বছৰযুৰি সুচল হ’ব লাগিব আৰু ৰাষ্ট্ৰীয়/ৰাজ্যিক ৰাজপথৰ সংযোগী আৰু নিকটতম হোৱা উচিত ।",
                        "optedPlotIs": "উক্ত/নিৰ্বাচিত ভূমিখণ্ড",
                        "adjacentToBitumenBlockRoad": "এটা বিটুমেন/ব্ল’ক দিয়া পথৰ সংলগ্ন ",
                        "adjacentToMotorableGravelRoad": "শিল-বালি যুক্ত এটা সুচল পথৰ সংলগ্ন ",
                        "requireAdditionalRoad": "৫০০ মিটাৰতকৈ কম অতিৰিক্ত পথ মেৰামতিৰ প্ৰয়োজনীয়তা থকা",
                        "powerConnectivity11kvline": "১১ কিল’ভ’ল্ট ক্ষমতাযুক্ত বিজুলী শক্তিৰ সংযোগ",
                        "distanceFromDistribution": "নিকটতম সৰবৰাহকাৰী/যোগান স্থলৰ পৰা উক্ত/নিৰ্বাচিত ভূমিখণ্ডৰ দূৰত্ব নূন্যতম হোৱা উচিত । সংযোগী পৰিবহনৰ বাবে স্থাপিত ট্ৰান্সফ’ৰ্মাৰ বাহাল কৰা হৈছে ।",
                        "powerConnectionAvailable": "উক্ত/নিৰ্বাচিত ভূমিখণ্ডত বিজুলীশক্তি সংযোগৰ উপলব্ধতা",
                        "within100mtr": "১০০ মিটাৰৰ ভিতৰত",
                        "btwn100_500mtr": "১০০ ৰ পৰা ৫০০ মিটাৰৰ ভিতৰত ",
                        "btwn500mtr_1km": "৫০০ মিটাৰৰ পৰা ১ কিল’মিটাৰৰ ভিতৰত",
                        "daytimePowerAvailability": "দিনৰ ভাগত শক্তিৰ উপলব্ধতা",
                        "powerAvailabilityDescrip": "উক্ত/নিৰ্বাচিত ভূমিখণ্ডত আৰু সেই অঞ্চলত শক্তিৰ উপলব্ধতাৰ গড় সময়সীমা যথোপযুক্ত হোৱা উচিত । এক বিকল্প বিদ্যুৎ সৰবৰাহ যোগানৰ ক্ষমতা  অতিৰিক্ত ক্ষমতা হ’ব ।",
                        "powerAvailableFor": "দিনৰ ভাগত শক্তি উপলব্ধ",
                        "moreThan8hour": "৮ ঘণ্টাতকৈ বেছি",
                        "btwn6_8hour": "৬ ৰ পৰা ৮ ঘণ্টাৰ ভিতৰত",
                        "btwn4_6hour": "৪ ৰ পৰা ৬ ঘণ্টাৰ ভিতৰত",
                        "fullAddress": "সম্পূৰ্ণ ঠিকনা",
                        "latitude": "অক্ষাংশ",
                        "longitude": "দ্ৰাঘিমাংশ",
                        "bankDetails": "বেংকৰ বিৱৰণ",
                        "accountNo": "একাউণ্ট/খাতা নম্বৰ",
                        "accountHolderName": "গ্ৰাহকৰ নাম",
                        "ifscCode": "আই এফ এছ চি  ক’ড",
                        "branch": "শাখা",
                        "uploadPassbookCancelledCheck": "পাছবুকৰ সন্মুখ পৃষ্ঠা/কেন্সেল্ড চেক আপল’ড কৰক",
                        "gstNo": "জি এছ টি নম্বৰ",
                        "uploadGst": "জি এছ টিৰ নথিপত্ৰ আপল’ড কৰক",
                        "nonEcumbranceCertificateNo": "ভাৰমুক্তি প্ৰমাণপত্ৰৰ নম্বৰ",
                        "uploadNonEcumbraceDoc": "ভাৰমুক্তি প্ৰমাণপত্ৰ আপল’ড কৰক",
                        "uploadValuationDueDiligence": "মূল্যায়ন প্ৰতিবেদন আৰু যথাযথ শ্ৰম প্ৰতিবেদন আপল’ড কৰক",
                        "agreementDetails": "চুক্তিৰ বিৱৰণ",
                        "licenseAgreementDetails": "অনুজ্ঞাপত্ৰ আৰু চুক্তিৰ বিৱৰণ",
                        "qualificationFinancialDetails": "অৰ্হতা আৰু বিত্তীয় তথ্য",
                        "agreementStartDate": "চুক্তিৰ আৰম্ভণি তাৰিখ",
                        "agreementEndDate": "চুক্তিৰ অন্তিম তাৰিখ",
                        "uploadLoiAgreement": "এলঅ’আই আৰু চুক্তিৰ নথিপত্ৰ আপল’ড কৰক",
                        "informationOfOptedStorageLocation": "সংৰক্ষণৰ বাবে নিৰ্বাচিত কৰা অৱস্থানৰ তথ্য ",
                        "uploadPlotImageWithTimeLocationStamp": "সময়, তাৰিখ আৰু অৱস্থানৰ ছীলসহ ভূমিখণ্ডৰ চিত্ৰ আপল’ড কৰক",
                        "powerConnectivity": "শক্তিৰ সংযোগ",
                        "landFillingRequired": "মাটি পূৰোৱা/ভৰোৱাৰ প্ৰয়োজনীয়তা",
                        "yes": "হয়",
                        "no": "নহয়",
                        "existingBoundaryFenceOrWall": "সীমাত অৱস্থিত বেৰ",
                        "anyExistingInfraOnPlot": "ভূমিখণ্ডত যিকোনো আন্তঃগাঁথনিৰ অৱস্থিতি",
                        "existingInfrastructure": "অৱস্থিত আন্তঃগাঁথনি",
                        "save&exit": "সংৰক্ষণ ও প্ৰস্থান ",
                        "save": "সংৰক্ষণ",
                        "preview": "পূৰ্বলোকন",
                        "enterPanNo": "পানকাৰ্ড নম্বৰ দাখিল কৰক",
                        "uploadPanDoc": "পানকাৰ্ড আপল’ড কৰক",
                        "addressProof": "ঠিকনাৰ প্ৰমাণপত্ৰ",
                        "enterLast4digit": "অন্তিম 4 টা সংখ্যা দাখিল কৰক",
                        "enterVoterId": "ভোটাৰ নম্বৰ দাখিল কৰক",
                        "enterDrivinglicense": "ড্ৰাইভিং লাইচেঞ্চ নম্বৰ দাখিল কৰক",
                        "enterBankPassbookNo": "বেংক পাছবুক নম্বৰ দাখিল কৰক",
                        "idProof": "পৰিচয় প্ৰমাণ পত্ৰ",
                        "enterIdProof": "পৰিচয় প্ৰমাণ পত্ৰ দাখিল কৰক",
                        "enterNo": "নম্বৰ দাখিল কৰক",
                        "uploadFile": "ফাইল আপল’ড কৰক",
                        "uploadFileTypeNote": "(কেৱল .png, .jpg, .jpeg, .pdf ফাইল আপল’ড কৰক। ফাইলৰ আকাৰৰ সীমা= ৫ এমবি)",
                        "uploadPhotoOfApproachRoad": "নিৰ্ধাৰিত ক্ষেত্ৰলৈ যোৱা পথৰ  চিত্ৰ আপল'ড কৰক",
                        "mandatoryRequirements": "অনিবাৰ্য আৱশ্যকতা",
                        "financialStrength": "বিত্তীয় শক্তি",
                        "financialDescrip": "আবেদনকাৰী গৰাকী প্ৰকল্পটোৰ বাবে মূলধন আৰু কাৰ্যকৰী মূলধন ৬০-৭০ লাখ টকাৰ ব্যৱস্থা কৰিব পৰাকৈ আৰ্থিকভাৱে স্বচ্ছল হ’ব লাগিব । তৎসত্ত্বেও এ বি ই পি এলএ বেংক/বিত্তীয় অনুষ্ঠান আৰু অন্য কেন্দ্ৰীয়/ৰাজ্যিক যোজনা আদিৰ পৰা আৰ্থিক সহায় আগবঢ়াব পাৰে। ",
                        "mobileNetworkConnectivity": "ম’বাইল নেটওৱৰ্ক স্ংযোগ",
                        "mobileConnectivityDescrip": "উক্ত স্থানসমূহত কাৰ্যকৰিতা আৰু যোগাযোগৰ সুবিধাৰ বাবে শক্তিশালী নেটওৱৰ্ক সংযোগ থকাউচিত । ",
                        "environmentSustainability": "পৰিবেশ আৰু ভাৰসাম্যতা",
                        "wildlifeCorridor": "বন্যপ্ৰাণীৰ মাৰ্গ",
                        "wildlifeCorridorDescrip": "উক্ত স্থানসমূহ বন্যপ্ৰাণীৰ মাৰ্গৰ ভিতৰত অৱস্থিত হ’ব নালাগিব আৰু বাসস্থান মুক্ত হ’ব লাগিব।",
                        "ecologicalBufferZone": "পাৰিস্থিতিক মধ্যৱৰ্তী ক্ষেত্ৰ ",
                        "ecologicalBufferZoneDescrip": "http://moef.gov.in/rules-and-regulations/esz-notifications ত উল্লেখ কৰা অনুসৰি  উক্ত স্থানসমূহ নিৰ্দিষ্ট পৰিৱেশ অঞ্চলৰ পৰা ১০ কিলোমিটাৰৰ ভিতৰত হ’ব নালাগিব",
                        "forestDescrip": "উক্ত স্থানসমূহ চৰকাৰৰ দ্বাৰা সংৰক্ষিত বনাঞ্চলৰ ৫০০ মি ৰ ভিতৰত অৱস্থিত হ’ব নালাগিব । ",
                        "soil": "মাটি",
                        "soilDescrip": "উক্ত স্থানসমূহ ভূমিক্ষয়ৰ সংকটৰ পৰা মুক্ত হ’ব লাগিব ।",
                        "water": "পানী",
                        "waterDescrip": "উক্ত স্থানসমূহ জলাশয়ৰ ওচৰত হ’ব নালাগিব ।",
                        "flora&fauna": "উদ্ভিদ আৰু প্ৰাণী",
                        "flora&faunaDescrip": "উক্ত স্থানসমূহ মোকলাবলৈ স্থানীয় অথবা সংকটগ্ৰস্ত প্ৰাণী আৰু প্ৰতিবন্ধিত পৰিসৰৰ উদ্ভিদ প্ৰজাতি ধ্বংস কৰিব নালাগিব ।",
                        "archaeologicalSite": "প্ৰত্নতাত্ত্বিক স্থান",
                        "archaeologicalSiteDescrip": "উক্ত স্থানসমূহ প্ৰত্নতাত্ত্বিক স্থান (এএছআই ৰ দ্বাৰা বিজ্ঞাপিত) অথবা এটা গুৰুত্বপূৰ্ণ সাংস্কৃতিক ঐতিহ্যৰ নিকটৱৰ্তী হ'ব নালাগিব, যিটো সংৰক্ষণৰ প্ৰয়োজন ।",
                        "social": "সামাজিক",
                        "forcedEviction": "বলপূৰ্বক উচ্ছেদ",
                        "forcedEvictionDescrip": "বলপূৰ্বক উচ্ছেদ অথবা উৎপাতনৰ পৰা সংকটমুক্ত হ'ব লাগিব ।",
                        "localEmployment": "স্থানীয় কৰ্মনিয়োজন",
                        "localEmploymentDescrip": "প্ৰকল্পটো সম্প্ৰদায়টোৰ উন্নতিৰ বাবে অন্যধৰণে চেষ্টাশীল হ'ব লাগিব, যেনে কৰ্মনিয়োগৰ সৃষ্টি, জীৱিকাৰ সৃষ্টি যিয়ে মৌলিক চাহিদা পূৰণ কৰে আৰু অন্তৰ্ভুক্তিৰ মূল্য শৃংখলা সংলগ্ন কৰে । এবিইপিএল এ শিশু শ্ৰমিক অথবা বাধ্যতামূলক শ্ৰমক সমৰ্থন নকৰে ।",
                        "generalTerms&Conditions": "সাধাৰণ স্বৰ্তাৱলী",
                        "termHeading": "পৰিবেশ, স্বাস্থ্য আৰু সুৰক্ষা নীতি আৰু আইন আৰু তথ্য আৰু প্ৰযুক্তি ব্যৱহাৰকাৰী আবেদন",
                        "term1": "আবেদনকাৰীৰ শ্ৰম অনুশীলন, মানৱ অধিকাৰ, দুৰ্নীতি আৰু উৎকোচ, পেছাদাৰী স্বাস্থ্য, সুৰক্ষা আৰু পৰিবেশ সম্পৰ্কীয় প্ৰযোজ্য নীতি আৰু আইনসমূহ পালনকাৰী হ'ব লাগিব আৰু ম'বাইল উপভোক্তাৰ ব্যৱস্থাপনাৰ জ্ঞান থাকিব লাগিব ।",
                        "termSubheading": "বাঁহ উৎসৰ বহনশীলতাৰ জ্ঞান/সজাগতা",
                        "term2": "আবেদনকাৰীয়ে আৰ্থিক, পৰিবেশ সম্বন্ধীয় আৰু সামাজিক প্ৰভাৱৰ ওপৰত প্ৰাথমিকতাৰ আধাৰত বিবেচনা কৰিব লাগিব । আবেদনকাৰীয়ে সৰবৰাহ শৃংখলাৰ সংসাধন ক্ষমতাক উন্নীত কৰাৰ লগতে বিনিয়োগকাৰীসকলকো অধিক বহনশীল হ'বলৈ নিৰ্দেশ দিব লাগিব ।",
                        "undertaking": "সংকল্প",
                        "termSubheading2": "মই এই আবেদন পত্ৰত নিৰ্দিষ্টভাৱে উল্লেখিত সবিশেষ বিজ্ঞপ্তি, বাধ্যতামূলক প্ৰয়োজনীয়তা আৰু সাধাৰণ স্বৰ্তাৱলী নিৰীক্ষণ কৰিছো ।",
                        "term3": "ইয়াৰ জৰিয়তে মই নিশ্চিত কৰো যে ওপৰত উল্লেখিত তথ্যসমূহ সম্পূৰ্ণৰূপে শুদ্ধ আৰু বিশ্বাসযোগ্য । যিকোনো ভুল/আপত্তিজনক তথ্যই মোৰ/আমাৰ উদ্যোগশীল বিবেচনাক অগ্ৰাহ্য কৰিব ।",
                        "enterMOA": "এম অ' এ প্ৰদান কৰক",
                        "enterRegNo": "পঞ্জীয়ন নং প্ৰদান কৰক",
                        "enterGSTNo": "জি এছ টি নম্বৰ প্ৰদান কৰক",
                        "r": "ৰ",
                        "clear": "পৰিষ্কাৰ",
                        "landAreaBigha": "ভূমি এলেকা (বিঘাত)",
                    },
                    "reg": {
                        "registration": "পঞ্জীকৰণ",
                        "panNumber": "পানকাৰ্ড নম্বৰ",
                        "uploadIDProofDoc": "পৰিচয় প্ৰমাণপত্ৰৰ নথিপত্ৰ আপল’ড কৰক ",
                        "registrationDetails": "পঞ্জীয়নৰ বিৱৰণ",
                        "land": "ভূমি",
                        "landType": "ভূমিৰ প্ৰকাৰ",
                        "landName": "ভূমিৰ নাম",
                        "totalBambooQuantity": "মুঠ বাঁহৰ পৰিমাণ (মেট্ৰিক টন)",
                        "committedQuantity": "নিয়োজিত পৰিমাণ (মেট্ৰিক টন)",
                        "actions": "ক্ৰিয়াকলাপ",
                        "edit": "সম্পাদন কৰক",
                        "addNewLand": "নতুন ভূমি সংলগ্ন কৰক",
                        "captive": "বন্দী",
                        "startDate": "আৰম্ভণিৰ তাৰিখ",
                        "endDate": "অন্তিম তাৰিখ",
                        "validTill": "টিল বৈধ",
                        "hilly": "পাহাৰীয়া",
                        "plain": "সমভূমি",
                        "trench": "খাৱৈযুক্ত",
                        "easeOfSourcing": "উৎপত্তিৰ বাবে উজু",
                        "sidingRequirement": "পক্ষাবলম্বনৰ প্ৰয়োজন",
                        "sidingRequirementInMeter": " মিটাৰত পক্ষাবলম্বনৰ প্ৰয়োজনীয়তা",
                        "distanceInMetersForLoading": "ভাৰবহনৰ বাবে নিকটতম বাহন চলাচল কেন্দ্ৰ/ক্ষেত্ৰ/স্থানৰ দূৰত্ব (মিটাৰ)",
                        "sidingDistance": "পক্ষাবলম্বনৰ দূৰত্ব",
                        "aggregationPoint": "একত্ৰীকৰণ কেন্দ্ৰ",
                        "aggregationPointName&Address": "একত্ৰীকৰণ কেন্দ্ৰৰ নাম আৰু ঠিকনা",
                        "leaseAgreement": "লীজৰ চুক্তি",
                        "uploadOwnedLandDoc": "মাটিৰ নথিপত্ৰ যেনে জমাবন্দী/ ভূমিধাৰণ প্ৰমাণ পত্ৰ/ খাজনা ৰছিদ/ তফসিল বহিৰ্ভূত মাটিৰ ক্ষেত্ৰত গাওঁ প্ৰাধিকৰণৰ বিবৃতিৰ  প্ৰতিলিপি আপল'ড কৰক",
                        "addBambooDetails": "বাঁহৰ সবিশেষ সংলগ্ন কৰক",
                        "speciesType": "প্ৰজাতিৰ ধৰণ",
                        "speciesName": "প্ৰজাতিৰ নাম",
                        "bambooSpecies": "বাঁহৰ প্ৰজাতি",
                        "noOfClumps": "গোটৰ সংখ্যা",
                        "ageOfClump": "গোটৰ বয়স (বছৰ)",
                        "avgClumpSize": "গোটৰ গড় আকাৰ",
                        "avgWeightOfBambooPole": "ডাল বাঁহৰ গড় ওজন (কিগ্ৰা)",
                        "avgHeightOfBambooPole": "ডাল বাঁহৰ গড় উচ্চতা (ফুট)",
                        "bambooPoleDiameter": "ডাল বাঁহৰ ব্যাস (মিলিমিটাৰ)",
                        "bambooPoleWallThickness": "ডাল বাঁহৰ বেৰৰ ঘনত্ব (মিলিমিটাৰ)",
                        "annual": "বাৰ্ষিক",
                        "monthly": "মাহিলি",
                        "cancel": "বাতিল কৰক",
                        "add": "সংযোগ কৰক",
                        "update": "আপডেট",
                        "addland": "ভূমি সংলগ্ন কৰক",
                        "updateLand": "ভূমি বিৱৰণ আপডেট কৰক",
                        "getLocation": "অৱস্থানৰ বিৱৰণ লাভ কৰক",
                        "growerType": "উৎপাদকৰ উপশ্ৰেণী",
                        "uploadLOI&AgreementDoc": "এলঅ’আই আৰু চুক্তিপত্ৰ আপল’ড কৰক",
                        "uploadHarvestingPlanDoc": "অন্য নথিপত্ৰ আপল'ড কৰক",
                        "addNewMember": "নতুন সদস্য সন্নিবিষ্ট কৰক",
                        "contactPersonName": "যোগাযোগৰ ব্যক্তিৰ নাম",
                        "contactPersonNumber": "যোগাযোগৰ ব্যক্তিৰ নম্বৰ",
                        "divisionalForestOffice": "বিভাগীয় বন কাৰ্যালয়",
                        "forestRangeOffice": "বন পৰিসীমা কাৰ্যালয়",
                        "forestBeatOffice": "বন বীট কাৰ্যালয়",
                        "fullName": "সম্পূৰ্ণ নাম",
                        "uploadAddressProofDoc": "ঠিকনা প্ৰমাণ নথিপত্ৰ আপল'ড কৰক",
                        "tradeLicenseNo": "বাণিজ্যিক অনুমতি পত্ৰৰ নম্বৰ",
                        "uploadTradeLicenseDoc": "পৰিবহনকাৰীৰ বাণিজ্যিক অনুজণজ্ঞাপত্ৰ আপল’ড কৰক",
                        "labourLicenseNo": "শ্ৰমিক অনুমতি পত্ৰৰ নম্বৰ ",
                        "uploadLabourLicenseDoc": "শ্ৰমিক অনুজণজ্ঞাপত্ৰ আপল’ড কৰক",
                        "uploadLast6monthsBankStatement": "যোৱা ৬ মাহৰ বেংকৰ বিবৃতি আপল’ড কৰক",
                        "totalVehicleCount": "মুঠ বাহনৰ সংখ্যা",
                        "totalManpower": "মুঠ জনশক্তি",
                        "addManpowerDetails": "জনশক্তিৰ বিৱৰণ সংযোগ কৰক",
                        "driverDetails": "চালকৰ বিৱৰণ",
                        "harvesterDetails": "সৰবৰাহকাৰীৰ বিৱৰণ",
                        "vehicleDetails": "বাহনৰ বিৱৰণ",
                        "experience": "অভিজ্ঞতা",
                        "licenseNo": "অনুজ্ঞাপত্ৰৰ নম্বৰ",
                        "trainingStatus": " প্ৰশিক্ষণৰ  স্থিতি",
                        "addVehicleDetails": "বাহনৰ বিৱৰণ সংযোগ কৰক",
                        "registrationNo": " পঞ্জীকৰণ নম্বৰ",
                        "grossWeightinKg": "মুঠ ওজন (কিগ্ৰা)",
                        "vehicleCapacityinKg": "বাহনৰ ক্ষমতা (কিগ্ৰা)",
                        "insuranceNo": "বীমা নম্বৰ",
                        "manpowerDetails": "জনশক্তিৰ বিৱৰণ",
                        "type": "প্ৰকাৰ",
                        "age": "বয়স",
                        "drivingLicenseNo": "চালকৰ অনুজ্ঞাপত্ৰৰ নম্বৰ",
                        "contactNo": "যোগাযোগ নম্বৰ",
                        "drivingExperienceIn": "বাহন চলোৱাৰ অভিজ্ঞতা",
                        "uploadDrivingLicenseDoc": "চালকৰ অনুজ্ঞাপত্ৰৰ প্ৰতিলিপি আপল'ড কৰক",
                        "years": "বছৰ",
                        "months": "মাহ",
                        "driver": "চালক",
                        "harvester": "সৰবৰাহকাৰী",
                        "trainingCompleted": "প্ৰশিক্ষণ সম্পূৰ্ণ কৰা হৈছে",
                        "uploadTrainingCompletionDoc": "প্ৰশিক্ষণ সম্পূৰ্ণ হোৱাৰ প্ৰমাণ পত্ৰ আপল'ড কৰক",
                        "grossVehicleWeight": "বাহনৰ মুঠ ওজন (কিলোগ্ৰাম)",
                        "unladenWeight": "ভাৰমুক্ত বাহনৰ ওজন (কিলোগ্ৰাম)",
                        "vehicleMake": "বাহনৰ গঠন",
                        "vehicleModel": "বাহনৰ মডেল",
                        "vehicleAgeInYears": "বাহনৰ বয়স (বছৰ)",
                        "uploadVehicleRegistrationDoc": "বাহন পঞ্জীয়নৰ নথিপত্ৰ আপল'ড কৰক",
                        "uploadInsuranceDoc": "বাহনৰ বীমা নথিপত্ৰ আপল'ড কৰক",
                        "puccNo": "পি ইউ চি চি নম্বৰ",
                        "uploadPuccDoc": "বাহন পি ইউ চি চি নথিপত্ৰ আপল'ড কৰক",
                        "fitnessNo": "ফিটনেছ/কাৰ্যক্ষমতা নম্বৰ",
                        "uploadFitnessDoc": "বাহনৰ ফিটনেছ/কাৰ্যক্ষমতা নথিপত্ৰ আপল'ড কৰক",
                        "uploadRegistrationDoc": "পঞ্জীয়ন প্ৰমাণপত্ৰ আপল'ড কৰক",
                        "areasOfOperation": "কাৰ্য্যকৰী ক্ষেত্ৰসমূহ",
                        "area1": "ক্ষেত্ৰ ১",
                        "area2": "ক্ষেত্ৰ ২",
                        "area3": "ক্ষেত্ৰ ৩",
                        "area4": "ক্ষেত্ৰ ৪",
                        "area5": "ক্ষেত্ৰ ৫",
                        "area6": "ক্ষেত্ৰ ৬",
                        "area7": "ক্ষেত্ৰ ৭",
                        "area8": "ক্ষেত্ৰ ৮",
                        "addDriverDetails": "চালকৰ বিৱৰণ সংলগ্ন কৰক",
                        "ownership": "মালিকীস্বত্ব",
                        "nationalPermit": "ৰাষ্ট্ৰীয় অনুজ্ঞাপত্ৰ",
                        "permitNo": "অনুজ্ঞাপত্ৰ নম্বৰ",
                        "uploadNationalPermitDoc": "ৰাষ্ট্ৰীয় অনুজ্ঞাপত্ৰৰ নথিপত্ৰ আপল'ড কৰক",
                        "uploadQualificationProofDoc": "অৰ্হতাৰ প্ৰমাণপত্ৰ আপল'ড কৰক",
                        "licenseDetails": "অনুজ্ঞাপত্ৰৰ বিৱৰণ",
                        "uploadTradeLicenseProofDoc": "বাণিজ্যিক অনুমতি প্ৰমাণপত্ৰ আপল'ড কৰক",
                        "uploadResidencePrrofMoaAdhar": "বাসস্থানৰ প্ৰমাণ আপল'ড কৰক (আধাৰ/ ভোটাৰ/ ৰেচন কাৰ্ড/ পাছপ'ৰ্ট/ এম অ' এ বা সমাজৰ পঞ্জীয়ন/ এছ এইচ জি/ ফাৰ্ম/ কোম্পানী)",
                        "nameOfForestDivisionOffice": "বন বিভাগীয় কাৰ্যালয়ৰ নাম",
                        "royaltyCharge": "ৰাজকীয় আয়",
                        "otherFees": "অন্যান্য মাচুল",
                        "fellingSeries": "পাতন শৃংখলা",
                        "rangeDetails": "পৰিসীমাৰ বিৱৰণ",
                        "boundaryEast": "পূৱ পৰিসীমা",
                        "boundaryWest": "পশ্চিম পৰিসীমা ",
                        "boundaryNorth": "উত্তৰ পৰিসীমা",
                        "boundarySouth": "দক্ষিণ পৰিসীমা",
                        "forestRangeOffice": "বন পৰিসীমাৰ কাৰ্যালয়",
                        "forestRangeOfficer": "বন পৰিসীমা অধিকাৰী",
                        "authorizedContactNo": "প্ৰাধিকৃত যোগাযোগৰ নম্বৰ",
                        "officeAddress": "কাৰ্যালয়ৰ ঠিকনা",
                        "addNewRange": "নতুন পৰিসীমা সন্নিবিষ্ট কৰক",
                        "addNewBeat": "নতুন বীট ক্ষেত্ৰ সন্নিবিষ্ট কৰক",
                        "forestBeatOffice": "বন বীটক্ষেত্ৰ কাৰ্যালয়",
                        "forestBeatOfficer": "বন বীটক্ষেত্ৰ অধিকাৰী",
                        "addRange": "পৰিসীমা সন্নিবিষ্ট কৰক",
                        "addBeat": "বীট ক্ষেত্ৰ সন্নিবিষ্ট কৰক",
                        "updateBeat": "বীট ক্ষেত্ৰ বিৱৰণ আপডেট কৰক",
                        "updateRange": "পৰিসীমা বিৱৰণ আপডেট কৰক",
                        "beatDetails": "বীটক্ষেত্ৰ বিৱৰণ",
                        "beatLandDetails": "বীটক্ষেত্ৰ ভূমিৰ বিৱৰণ",
                        "yes2": "আছে",
                        "no2": "নাই",
                        "uploadLandForestMapDoc": "ভূমিৰ নথি যেনে চৰকাৰী/বন বিভাগৰ বৰ্গীকৃত ভূমিৰ মানচিত্ৰ আপল'ড কৰক",
                        "forestCoupeAvailable": "বন পাতন অংশ উপলব্ধ",
                        "selectCoupes": "পাতন অংশ নিৰ্ব্বাচন কৰক",
                        "addNewFellingSeries": "নতুন পাতন শৃংখলা সন্নিবিষ্ট কৰক",
                        "addNewCoupe": "নতুন পাতন অংশ সন্নিবিষ্ট কৰক",
                        "coupeName": "পাতন অংশৰ নাম",
                        "coupeType": "পাতন অংশৰ প্ৰকাৰ",
                        "coupeDetails": "পাতন অংশৰ বিৱৰণ",
                        "forestCoupeName": "বন পাতন অংশৰ নাম",
                        "nameOfForestCoupeOfficer": "বন পাতন অংশৰ অধিকাৰীৰ নাম",
                        "uploadLandDoc": "মাটিৰ নথিপত্ৰ আপল'ড কৰক",
                        "addCoupe": "পাতন অংশ সন্নিবিষ্ট কৰক",
                        "updateCoupe": "পাতন অংশ বিৱৰণ আপডেট কৰক",
                        "dob": "জন্ম তাৰিখ",
                        "licenseIssuedDate": "অনুজ্ঞাপত্ৰ জাৰি কৰাৰ তাৰিখ",
                        "validityEndDate": "বৈধতা শেষ তাৰিখ",
                        "land details": "ভূমিৰ বিৱৰণ",
                        "bamboo species details": "বাঁহৰ প্ৰজাতিৰ বিৱৰণ",
                        "view": "প্ৰত্যক্ষ কৰক",
                        "comment": "মন্তব্য",
                        "comments": "মন্তব্যসমূহ",
                        "detailsOk": "বিৱৰণ ঠিক আছে",
                        "date": "তাৰিখ",
                        "commentHistory": "মন্তব্যইতিহাস",
                        "userRole": "ব্যৱহাৰকাৰীৰ ভূমিকা",
                        "uploadRelevantDOc": "প্ৰাসংগিক নথিপত্ৰসমূহ আপল'ড কৰক"
                    },
                    "dashboardStakeholder": {
                        "welcomeToStakeholderDashboard": "হিতাধিকাৰীৰ ফলকলৈ স্বাগতম!",
                        "pendingClarificationFromScru": "নিৰীক্ষকৰ পৰা অহা স্থগিত স্পষ্টীকৰণ",
                        "pendingClarificationFromResScru": "সমল নিৰীক্ষকৰ পৰা অহা স্থগিত স্পষ্টীকৰণ",
                        "requestSentforApproval": "অনুমোদনৰ বাবে প্ৰেৰিত নিবেদন",
                        "actionTaken": "পদক্ষেপ লোৱা হৈছে",
                        "manageWorklist": "কাৰ্য্যতালিকা পৰিচালনা কৰক"
                    },
                    "demand": {
                        "pendingDemandNotification": "অমীমাংসিত চাহিদাৰ অধিসূচনা",
                        "confirm": "নিশ্চিত কৰক",
                        "reject": "খাৰিজ কৰক",
                        "financialYear": "আৰ্থিক বৰ্ষ",
                        "month": "মাহ",
                        "growerLandId": "উৎপাদকৰ মাটিৰ আই ডি",
                        "tentativeMonthlyAllocationForChipping": "খণ্ডীকৰণৰ বাবে মাহিলী অন্তৰিম আৱন্তন",
                        "dailyChippingCapacity": "প্ৰতিদিনৰ ক্ষমতা",
                        "actualDailyCapacity": "প্ৰতিদিনৰ প্ৰকৃত ক্ষমতা",
                    },
                    "payment": {
                        "paymentStatus": "ধন আদায়ৰ স্থিতি",
                        "urn": "ইউআৰএন",
                        "referenceNo": "সন্দৰ্ভ নম্বৰ",
                        "typeOfPayment": "ধন আদায়ৰ প্ৰকাৰ",
                        "stakeholderCategory": "হিতাধিকাৰীৰ শ্ৰেণী",
                        "amountINR": "ধনৰাশি (টকা)",
                        "creationDate": "অন্তৰ্ভুক্তিৰ তাৰিখ",
                        "paymentDate": "ধন আদায়ৰ তাৰিখ (যদি আদায় কৰা হৈছে)",
                        "status": "স্থিতি",
                        "bankTransactionId": "বেংক লেনদেন আই ডি",
                        "liv Number": "লিভ নম্বৰ",
                    },
                    "resource": {
                        "viewKnowledgeManagement": "তথ্য ব্যৱস্থাপনা প্ৰত্যক্ষ কৰক",
                        "documentName": "নথিপত্ৰৰ নাম",
                        "stakeholderType": "হিতাধিকাৰীৰ প্ৰকাৰ",
                        "viewDocument": "নথিপত্ৰ প্ৰত্যক্ষ কৰক",
                        "downloadDocument": "নথিপত্ৰ ডাউনল’ড কৰক",
                        "view": "প্ৰত্যক্ষ কৰক",
                        "download": "ডাউনল’ড কৰক",
                        "createPlantationBatch": "বৃক্ষৰোপণ গোট সৃষ্টি কৰক",
                        "viewPlantationBatch": "বৃক্ষৰোপণ গোট প্ৰত্যক্ষ/আপডেট কৰক",
                        "proceed": "অগ্ৰসৰ হওক",
                        "selectLandToCreatePlantation": "বৃক্ষৰোপণ গোট সৃষ্টি কৰিবলৈ ভূমি নিৰ্বাচন কৰক",
                        "growerURN": "উৎপাদকৰ ইউআৰএন",
                        "growerName": "উৎপাদকৰ নাম",
                        "add": "প্ৰজাতি সন্নিবিষ্ট কৰক",
                        "edit": "প্ৰজাতি বিৱৰণ সম্পাদন কৰক",
                        "saplingType": "গছপুলিৰ প্ৰকাৰ",
                        "otherSaplingType": "অন্যান্য গছপুলিৰ প্ৰকাৰ",
                        "saplingQuantity": "গছপুলিৰ পৰিমাণ",
                        "saplingSource": "গছপুলিৰ উৎস",
                        "otherSaplingSource": "অন্যান্য গছপুলিৰ উৎস",
                        "spacingLength": "অন্তৰালৰ দীঘ",
                        "spacingWidth": "অন্তৰালৰ প্ৰস্থ ",
                        "noDataAvailable": "তথ্যশূন্য",
                        "dateOfNewPlantation": "নতুন বৃক্ষৰোপণৰ তাৰিখ",
                        "plantationMaturedDate": "বৃক্ষৰোপণৰ পৰিপক্ক তাৰিখ",
                        "uploadPhotos": "চিত্ৰ আপল’ড কৰক",
                        "uploadDocument": "নথিপত্ৰ আপল’ড কৰক",
                        "chooseFile": "ফাইল বাছনি কৰক",
                        "species": "প্ৰজাতি",
                        "urn": "ইউ আৰ এন",
                        "getPlantationDetails": "বৃক্ষৰোপণৰ বিৱৰণ লাভ কৰক",
                        "plantationBatch": "বৃক্ষৰোপণ গোট",
                        "dateOfPlantation": "বৃক্ষৰোপণৰ তাৰিখ",
                        "averageBambooPoleWeightinKg": "গড় বাঁহৰ খুঁটাৰ ওজন (কিলোগ্ৰামত)",
                        "totalLandArea(in Bigha)": "মুঠ মাটিকালি(বিঘাত)",
                        "availableLandArea(in Bigha)": "উপলব্ধ ভূমি এলেকা(বিঘাত)",
                        "existingLandArea(in Bigha)": "বিদ্যমান ভূমি এলেকা (বিঘাত)",
                        "plantationBatchNo": "বৃক্ষৰোপণ গোট নম্বৰ"
                    },
                    "helpdesk": {
                        "newIncident": "নৱ সংঘটন",
                        "newExternalIncident": "নতুন বাহ্যিক সংঘটন",
                        "dontHaveAnyTicket": "এই বিকল্পৰ অধীনত আপোনাৰ কোনো বিজ্ঞপ্তি নাই!!",
                        "id": "আই ডি",
                        "subject": "বিষয়",
                        "requesterName": "নিবেদনকাৰীৰ নাম",
                        "requestedBy": "উত্থাপক",
                        "requestedFor": "অনুৰোধকাৰী",
                        "supportExecutive": "সহায়ক কাৰ্যবাহী",
                        "category": "শ্ৰেণী",
                        "subCategory": "উপশ্ৰেণী",
                        "status": "স্থিতি",
                        "dueByDate": "নিৰ্ধাৰিত তাৰিখ",
                        "createdDate": "সৃষ্ট তাৰিখ",
                        "edit": "সম্পাদন কৰক",
                        "userId": "ব্যৱহাৰকৰ্তাৰ আই ডি",
                        "userName": "ব্যৱহাৰকৰ্তাৰ নাম",
                        "contactNo": "যোগাযোগৰ নম্বৰ",
                        "urn": "ইউআৰএন",
                        "requesterUrnEmail": "নিবেদনকাৰীৰ ইউ আৰ এন/ইমেইল",
                        "requestType": "নিবেদনৰ প্ৰকাৰ",
                        "select": "নিৰ্বাচন কৰক",
                        "save": "সংৰক্ষণ",
                        "helpTopics": "সহায় বিষয়",
                        "createTicket": "টিকট তৈয়াৰ কৰক",
                        "stillNotSatisfied": "এতিয়াও সন্তুষ্ট হোৱা নাই?",
                        "satisfied": "সন্তুষ্ট",
                        "description": "বিৱৰণ",
                        "updateRequesterDetails": "নিবেদনকাৰীৰ বিৱৰণ আপডেট কৰক",
                        "searchByContact": "যোগাযোগৰ দ্বাৰা সন্ধান কৰক",
                        "searchByUrn": "ইউ আৰ এন দ্বাৰা সন্ধান কৰক",
                        "searchByEmail": "ইমেইল দ্বাৰা সন্ধান কৰক",
                        "or": "অথবা",
                        "stakeholder": "হিতাধিকাৰী",
                        "guest": "অতিথি",
                        "addRequesterUrn": "নিবেদনকাৰীৰ ইউ আৰ এন যোগ কৰক",
                        "addRequesterEmail": "নিবেদনকাৰীৰ ইমেইল",
                        "addRequesterContact": "নিবেদনকাৰীৰ যোগাযোগ নম্বৰ যোগ কৰক",
                        "addGuestContact": "অতিথি যোগাযোগ নম্বৰ যোগ কৰক",
                        "searchByGuestContact": "অতিথি যোগাযোগৰ দ্বাৰা সন্ধান কৰক",
                        "dontHaveValidDetails": "বৈধ সবিশেষ নাই নেকি?",
                        "applyAsNewGuest": "নতুন অতিথি হিচাপে আবেদন কৰক",
                        "noFaqFound": "কোনো FAQ পোৱা নগ'ল !",
                        "uploadYourFileHere": "আপোনাৰ ফাইলটো ইয়াত আপল'ড কৰক",
                        "browse": "ব্ৰাউজ কৰক",
                        "supportedFile": "সমৰ্থিত ফাইলসমূহ:pdf,png.",
                        "grievanceResolution": "অভিযোগ সমাধান",
                        "ticketNumber": "টিকট নম্বৰ",
                        "priority": "অগ্ৰাধিকাৰ",
                        "sla": "এছ এল এ",
                        "noDescriptionAvailable": "কোনো বিৱৰণ উপলব্ধ নহয়",
                        "attachments": "অনুবন্ধ",
                        "worklogs": "ৱৰ্কলগসমূহ",
                        "addComment": "মন্তব্য যোগ কৰক",
                        "comment": "মন্তব্য",
                        "changedBy": "সলনি",
                        "changedTimestamp": "পৰিৱৰ্তিত টাইমষ্টেম্প",
                        "faqs": "এফএকিউচ",
                        "faqDownload": "এফএকিউচ ডাউনল’ড কৰক",
                        "newWorklog": "নতুন ৱৰ্কলগ",
                    },
                    "pit": {
                        "poList": "পিঅ’ তালিকা",
                        "soList": "এছ.ও. তালিকা",
                        "stoList": "এছ টি ও তালিকা",
                        "scoList": "এছ চি অ’ তালিকা",
                        "poDate": "পিঅ তাৰিখ",
                        "soDate": "এছ.ও. তাৰিখ",
                        "stoDate": "এছ টি ও তাৰিখ",
                        "scoDate": "এছ চি অ’ তাৰিখ",
                        "poNo": "পিঅ’ নম্বৰ",
                        "planningNo": "পৰিকল্পনা নম্বৰ",
                        "year": "বছৰ",
                        "month": "মাহ",
                        "stakeholderName": "হিতাধিকাৰীৰ নাম",
                        "stakeholderUrn": "হিতাধিকাৰীৰ ইউ আৰ এন",
                        "quantity": "পৰিমাণ ",
                        "ActualQuantity": "প্ৰকৃত পৰিমাণ (এম টি)",
                        "ExpectedQuantity": "প্ৰত্যাশিত পৰিমাণ (এম টি)",
                        "poQuantity": "পিঅ’ পৰিমাণ",
                        "balanceQuantity": "পিঅ’ ভাৰসাম্য পৰিমাণ (এম টি)",
                        "soQuantity": "এছ.ও. পৰিমাণ",
                        "soBalanceQuantity": "এছ.ও. ভাৰসাম্য পৰিমাণ (এম টি)",
                        "stoQuantity": "এছ টি ও  পৰিমাণ",
                        "stoBalanceQuantity": "এছ টি ও  ভাৰসাম্য পৰিমাণ (এম টি)",
                        "scoQuantity": "এছ চি অ’  পৰিমাণ",
                        "scoBalanceQuantity": "এছ চি অ’  ভাৰসাম্য পৰিমাণ (এম টি)",
                        "view": "প্ৰত্যক্ষ কৰক",
                        "growerPo": "উৎপাদক পিঅ’",
                        "vendorDetails": "বিক্ৰেতাৰ বিৱৰণ",
                        "name": "নাম",
                        "urn": "ইউআৰএন",
                        "contactPerson": "যোগাযোগকাৰী ব্যক্তি",
                        "phoneNumber": "যোগাযোগৰ নম্বৰ",
                        "address": "ঠিকনা",
                        "lineNo": "ক্ৰমিক নং",
                        "itemCode": "পণ্যসামগ্ৰীৰ সংকেতচিহ্ন",
                        "itemDesc": "পণ্যসামগ্ৰীৰ বিৱৰণ",
                        "itemType": "পণ্যসামগ্ৰীৰ প্ৰকাৰ",
                        "uom": "ইউঅ’এম",
                        "shipTo": "পৰিবহন/প্ৰেৰণৰ স্থান (নাম ও ঠিকনা)",
                        "billTo": "বয়নামা গ্ৰাহক (নাম ও ঠিকনা)  ",
                        "deliveryDate": "বিতৰণৰ তাৰিখ",
                        "validityDate": "বৈধতা তাৰিখ",
                        "price": "মূল্য (টকা)",
                        "cgst": "চিজিএছটি",
                        "sgst": "এছজিএছটি",
                        "igst": "আইজিএছটি",
                        "total": "মুঠ (কৰ বাদ দি)(টকা)",
                        "customerDetails": "গ্ৰাহকৰ বিৱৰণ",
                        "download": "ডাউনল’ড কৰক",
                        "print": "প্ৰিন্ট কৰক",
                        "weeklyPickupPlan": "সাপ্তাহিক মালবাহী যোজনা",
                        "scheduleFrom": "পৰা",
                        "scheduleTo": "লৈ",
                        "scheduleNo": " সময়সূচী নং",
                        "scheduleLineNo": "সময়সূচী ক্ৰমিক নং",
                        "pickUpDate": "মালবাহী তাৰিখ",
                        "urn1stParty": "ইউআৰএন (১ম পক্ষ)",
                        "contactDetails1stParty": "যোগাযোগৰ বিৱৰণ (১ম পক্ষ)",
                        "location1stParty": "স্থান (১ম পক্ষ)",
                        "urn2ndParty": "ইউআৰএন (২য় পক্ষ)",
                        "contactDetails2ndDetails": "যোগাযোগৰ বিৱৰণ (২য় পক্ষ)",
                        "location2ndParty": "স্থান (২য় পক্ষ)",
                        "landId": "মাটিৰ আই ডি",
                        "typeOfInventory": "বিস্তৃতিমূলক সূচীৰ প্ৰকাৰ",
                        "approvalStatus": "অনুমোদনৰ স্থিতি",
                        "harvestingDetails": "সংৰক্ষণ সবিশেষ",
                        "invoiceList": "চালানৰ সূচী",
                        "pending": "স্থগিত",
                        "accepted": "গ্ৰাহ্য",
                        "rejected": "বৰ্জিত",
                        "invoiceNo": "চালান নম্বৰ",
                        "invoiceType": "চালানৰ শ্ৰেণী",
                        "gstIn": "জিএছটিআইএন",
                        "date": "তাৰিখ",
                        "status": "স্থিতি",
                        "approve": "অনুমোদন কৰক",
                        "accept": "গ্ৰহণ কৰক",
                        "reject": "বৰ্খাস্ত",
                        "growerInvoice": "উৎপাদক চালান",
                        "invoiceNo": "চালান নং",
                        "invoiceDate": "চালান তাৰিখ",
                        "vendorName": "বিক্ৰেতাৰ নাম",
                        "consignment": "হস্তান্তৰকৰণ নম্বৰ",
                        "invoiceType": "চালানৰ প্ৰকাৰ",
                        "orderDetails": "অৰ্ডাৰৰ বিৱৰণ",
                        "orderNo": "অৰ্ডাৰ নম্বৰ",
                        "orderDate": "অৰ্ডাৰৰ তাৰিখ",
                        "shippingDetails": "প্ৰেৰণৰ বিৱৰণ",
                        "shippingDate": "প্ৰেৰণৰ তাৰিখ",
                        "shippedByName": "প্ৰেৰক (নাম)",
                        "shippedByPhone": "প্ৰেৰক (ঠিকনা)",
                        "acknowledgmentId": "স্বীকৃতিৰ প্ৰমাণ",
                        "unitPer": "সমুদায় প্ৰতি",
                        "amount": "ধনৰাশি (টকা)",
                        "sumTotal": "যোগফল",
                        "ItemDescHSNCode": "পণ্যসামগ্ৰীৰ বিৱৰণ/এইচ্‌এছএন সংকেতচিহ্ন",
                        "consignmentList": "হস্তান্তৰকৰণ তালিকা",
                        "consignmentCreation": "চালান সৃষ্টি",
                        "consignmentNo": "হস্তান্তৰকৰণ নং",
                        "consignmentStatus": "হস্তান্তৰকৰণ স্থিতি",
                        "deliveryChallanNo": "বিতৰণ চালান নং",
                        "challanNo": "চালান নং",
                        "deliveryChallanDate": "বিতৰণ চালান তাৰিখ",
                        "sourceUrn": "উৎস ইউআৰএন ",
                        "sourceLocation": "উৎসৰ স্থান",
                        "destinationUrn": "গন্তব্যস্থল ইউআৰএন",
                        "destinationLocation": "গন্তব্যস্থলৰ অৱস্থিতি",
                        "vehicleNo": "বাহন নং",
                        "consignmentDetails": "হস্তান্তৰকৰণৰ বিৱৰণ",
                        "consignmentOwnerUrn": "হস্তান্তৰকৰণ স্বত্বাধিকাৰীৰ ইউআৰএন",
                        "schedulePickupDate": "সংগ্ৰহৰ তাৰিখ",
                        "vehicleRegistration": "বাহনৰ পঞ্জীকৰণ",
                        "consignmentOwnerName": "হস্তান্তৰকৰণ স্বত্বাধিকাৰীৰ নাম",
                        "scheduleConsignmentWeight": 'হস্তান্তৰকৰণৰ ভাৰ',
                        "deliveryLocationUrn": "বিতৰণৰ অৱস্থান ইউআৰএন",
                        "consignmentOwnerContact": "হস্তান্তৰকৰণ স্বত্বাধিকাৰীৰ যোগাযোগৰ নম্বৰ",
                        "deliveryLocationName": "বিতৰণৰ অৱস্থানৰ নাম",
                        "tareWeightMeasureLle": "স্থানীয় উদ্যোক্তাৰ স্থানত পৰিমিত বিশুদ্ধ ভাৰ",
                        "pickupLocationUrn": "সংগ্ৰহ অৱস্থানৰ ইউআৰএন",
                        "deliveryLocationAddress": "বিতৰণৰ অৱস্থানৰ ঠিকনা",
                        "averageMoistureDuringPickup": "সংগ্ৰহৰ সময়ৰ গড় আৰ্দ্ৰতা",
                        "pickupLocationName": "সংগ্ৰহ অৱস্থানৰ নাম",
                        "grossWeightMeasuredLle": "স্থানীয় উদ্যোক্তাৰ স্থানত পৰিমিত সৰ্বমুঠ ভাৰ",
                        "pickupLocationAddress": "সংগ্ৰহ অৱস্থানৰ ঠিকনা",
                        "typeOfLoading": "মালবহনৰ প্ৰকাৰ (এফটিএল/এলটিএল)",
                        "weightDuringPickup": "সংগ্ৰহৰ সময়ৰ ভাৰ(মেট্ৰিক টন)",
                        "sto": "এছটিঅ’",
                        "sco": "এছ চি অ’",
                        "driverName": "চালকৰ নাম",
                        "weightDuringPickupFromBundleSelection": "সংগ্ৰহৰ সময়ৰ নিৰ্বাচিত গোটৰ ভাৰ(মেট্ৰিক টন)",
                        "driverLicenseNo": "চালকৰ অনুজ্ঞাপত্ৰৰ নম্বৰ",
                        "odometerStartReading": "অ’ড’মিটাৰৰ আৰম্ভণিৰ মান",
                        "scheduleDeliveryDate": "বিতৰণৰ তাৰিখ",
                        "scheduleDate": "সূচী তাৰিখ",
                        "driverContact": "চালকৰ যোগাযোগ",
                        "firstPartyDetails": "প্ৰথম পক্ষৰ বিৱৰণ",
                        "firstPartyUrn": "প্ৰথম পক্ষৰ ইউআৰএন",
                        "firstPartyLocName": "প্ৰথম পক্ষৰ অৱস্থানৰ নাম",
                        "firstPartyLocAddress": "প্ৰথম পক্ষৰ অৱস্থানৰ ঠিকনা",
                        "secondPartyDetails": "দ্বিতীয় পক্ষৰ বিৱৰণ",
                        "grossWeightInMT": "সৰ্বমুঠ পৰিমিত ভাৰ (মৰ্ট্ৰিকট’ন)",
                        "tareWeightInMT": "বিশুদ্ধ পৰিমিত ভাৰ (মৰ্ট্ৰিকট’ন)",
                        "netWeightInMT": "মুঠ পৰিমিত ভাৰ (মৰ্ট্ৰিকট’ন)",
                        "averageMoisture": " গড় আৰ্দ্ৰতা",
                        "DeviationWeightPer": "বিচলন ভাৰ (শতকৰা হাৰ)",
                        "deviationMoisturePer": "বিচলন আৰ্দ্ৰতা (শতকৰা হাৰ)",
                        "invoiceDetails": "চালানৰ বিৱৰণ",
                        "invoiceAmount": "চালানৰ ধনৰাশি (আইএনআৰ)",
                        "urn": "ইউআৰএন",
                        "servicePo": "সেৱা পিও",
                        "soNo": "এছ.ও. নম্বৰ",
                        "stoNo": "এছ টি ও নম্বৰ",
                        "scoNo": "এছ চি অ’ নম্বৰ",
                        "destination stakeholder type": "গন্তব্য অংশীদাৰৰ প্ৰকাৰ",
                        "destination stakeholder URN": "গন্তব্য অংশীদাৰৰ ইউআৰএন",
                        "short close": "চুটি বন্ধ",
                        "short close qty": "চুটি বন্ধ পৰিমাণ",
                        "current Owner": "বৰ্তমান গৰাকী",
                        "received qty": "প্ৰাপ্ত পৰিমাণ",
                        "scheduled quantity": "অনুসূচীত পৰিমাণ",
                        "Modified PO Quantity": "পৰিবৰ্তিত পিও পৰিমাণ",
                        "Modified SO Quantity": "পৰিবৰ্তিত এছ ও পৰিমাণ",
                        "Modified STO Quantity": "পৰিবৰ্তিত এচ টি ও পৰিমাণ",
                        "Modified SCO Quantity": "পৰিবৰ্তিত এছ চি অ’ পৰিমাণ",
                        "update": "আপডেট",
                        "PO Pending List": "পি.ও.অমীমাংসিত তালিকা",
                        "SO Pending List": "এছ.ও.অমীমাংসিত তালিকা",
                        "STO Pending List": "এছ টি ও অমীমাংসিত তালিকা",
                        "SCO Pending List": "এছ চি অ’ অমীমাংসিত তালিকা",
                        "PO Approved List": "পি.ও.অনুমোদিত তালিকা ",
                        "SO Approved List": "এছ.ও.অনুমোদিত তালিকা ",
                        "STO Approved List": "এছ টি ও অনুমোদিত তালিকা ",
                        "SCO Approved List": "এছ চি অ’ অনুমোদিত তালিকা ",
                        "Modified PO": "পৰিবৰ্তিত পি.ও.",
                        "Modified SO": "পৰিবৰ্তিত এছ.ও.",
                        "Modified STO": "পৰিবৰ্তিত এছ টি ও",
                        "Modified SCO": "পৰিবৰ্তিত এছ চি অ’",
                        "Pending Modified PO List": "অমীমাংসিত পৰিবৰ্তিত পি.ও. তালিকা",
                        "Pending Modified SO List": "অমীমাংসিত পৰিবৰ্তিত এছ.ও.তালিকা",
                        "Pending Modified STO List": "অমীমাংসিত পৰিবৰ্তিত এছ টি ও তালিকা",
                        "Pending Modified SCO List": "অমীমাংসিত পৰিবৰ্তিত এছ চি অ’ তালিকা",
                        "Approved Modified PO List": "অনুমোদিত পৰিবৰ্তিত পি.ও. তালিকা",
                        "Approved Modified SO List": "অনুমোদিত পৰিবৰ্তিত এছ.ও.তালিকা",
                        "Approved Modified STO List": "অনুমোদিত পৰিবৰ্তিত এছ টি ও তালিকা",
                        "Approved Modified SCO List": "অনুমোদিত পৰিবৰ্তিত এছ চি অ’ তালিকা",
                        "To be modified PO": "পৰিবৰ্তন কৰিব লগীয়া পি.ও.",
                        "To be modified SO": "পৰিবৰ্তন কৰিব লগীয়া এছ.ও.",
                        "To be modified STO": "পৰিবৰ্তন কৰিব লগীয়া এছ টি ও",
                        "To be modified SCO": "পৰিবৰ্তন কৰিব লগীয়া এছ চি অ’",
                        "Unit Price": "একক মূল্য (INR)",
                        "Total Amount": "মুঠ ধনৰাশি (INR)",
                        "delete": "ডিলিট",
                        "edit": "সম্পাদনা কৰক",
                        "cancellationComment": "বাতিল কৰা মন্তব্য",
                        "consignmentCancel": "হস্তান্তৰকৰণ বাতিল কৰা",
                        "cancelHeader": 'এই হস্তান্তৰকৰণ বাতিল কৰিব বিচৰাটো নিশ্চিত নেকি? তলত এটা কাৰণ দিব।',
                        "cancellationReason": 'বাতিলৰ কাৰণ',
                        "Commentmandatory": 'বাতিলৰ বাবে মন্তব্য বাধ্যতামূলক।'
                    },
                    "sidebarStakeholder": {
                        "dashboard": "ফলক",
                        "helpdesk": "সাহায্য বেদী",
                        "requests": "নিবেদন",
                        "faqs": "এফ এ কিউচ",
                        "demand": "চাহিদা",
                        "pit": "পি আই টি",
                        "po": "পি অ’",
                        "weeklySchedule": "সাপ্তাহিক সূচী",
                        "invoices": "চালান",
                        "consignmentList": "হস্তান্তৰকৰণ তালিকা",
                        "paymentStatus": "আদায়কাৰী স্থিতি",
                        "registrationDetails": "পঞ্জীকৰণৰ বিৱৰণ",
                        "resource": "উৎস",
                        "viewKnowledgeManagement": "তথ্য ব্যৱস্থাপনা প্ৰত্যক্ষ কৰক",
                        "plantationBatch": "বৃক্ষৰোপণ গোট",
                        "userOnboarding": "ব্যৱহাৰকাৰী অনবৰ্ডিং"
                    },
                    "account": {
                        "upload photo": "ফটো আপল’ড কৰক",
                        "change password": "পাছৱৰ্ড সলনি কৰক",
                        "logout": "লগ আউট কৰক",
                    }
                }
            }
        }

    });

export default i18next